import {
  Component,
  OnInit,
  OnDestroy,
  ViewChildren,
  ViewChild,
  ElementRef,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { DirectionService } from '../../direction.service';

import { OrdersService, isPrintNodeStatusNegativeResponse, messageForPrintNodeHttpError } from './orders-service';
import { PageEvent } from '@angular/material/paginator';
import { AuthService } from 'src/app/auth/auth.service';
import { UsersService } from 'src/app/super-management/user/users.service';

import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'src/app/dialog/dialog.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import * as _ from 'lodash';

import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BranchesService } from 'src/app/super-management/branch/branches.service';
import { DataSharingService } from 'src/app/main-section/data-shering-service/data-sharing.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { PHOrdersService } from 'src/app/super-management/ph-manigment/ph-orders-service';
import { ChatService } from 'src/app/other-pages/chat/chat.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IsraelTimeService } from 'src/app/israel-time.service';
import { CommitmentTimeDisplayService } from 'src/app/services/commitment-time-display.service';
import {
  getPhCollectionServicePrice,
  getPhSystemIconSrcFromProduct,
  phProductMaterialI18nKey,
} from 'src/app/main-section/ph-printing-table/ph-service-data';
import { copyTextToClipboard } from 'src/app/utils/clipboard-copy';
import { resolveIsNotAcademyFromOrder, syncIsNotAcademyFromOrder } from 'src/app/utils/is-not-academy';
import { buildPlotterPaperUsageTooltip, hasPlotterPaperUsage } from 'src/app/utils/plotter-paper-usage';
import { WallSessionService } from 'src/app/wall/wall-session.service';
import { isWallPlaceholderThumb } from 'src/app/wall/wall-api.service';

@Component({
  selector: 'app-order-list',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.css'],
  host: {
    class: 'fill-screen',
  },
})
export class MyOrdersComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;

  isLoading = false;

  orders: any[] = [];
  unSortedOrders: any[] = [];
  lastPendingOrderIndex: number = 0;

  totalOrders = 0;
  ordersPerPage = 20;
  currentPage = 1;
  pageSizeOptions = [5, 10, 20, 30, 50];
  userIsAuthenticated = false;
  userId: string;
  user: any;
  /** When navigating to userorders/:userId/:orderId – show only this order or "הזמנה ישנה" if not in last 100 */
  orderIdFromRoute: string | null = null;
  showOldOrderMessage = false;
  private ordersSub: Subscription;
  private authStatusSub: Subscription;
  private intervalId: any;
  isLoadOrders: boolean = true;
  /** "הצג עמודים נוספים" — לפי הזמנה+קובץ, נשמר בין רענוני שרת */
  allImagesExpandedKeys = new Set<string>();
  isManagementView: boolean = false;
  isSU: boolean = false;
  isBmph: boolean = false;

  expandedPanelId: string | number;
  @ViewChildren(MatExpansionPanel) expansionPanels;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;

  plotterImageErrors: boolean[] = [];
  expressImageErrors1: boolean[] = [];
  expressImageErrors2: boolean[] = [];
  private orderDeletedSub: Subscription;
  private priceQuoteSentSuccessSub: Subscription;
  private productionStartedSuccessSub: Subscription;
  private productionFinishedSuccessSub: Subscription;
  private arrivedAtAddressSuccessSub: Subscription;
  private creditOrderSuccessSub: Subscription;
  private rolesSub: Subscription;

  @ViewChildren(MatMenuTrigger) menuTriggers!: QueryList<MatMenuTrigger>;

  expressServerAdress: string = 'https://img-express.eazix.io';

  // ph
  isPHOrdered: boolean = true;
  isPHOrderExisting: boolean = false;
  markProductionFinishedLoading = false;
  /** האם להציג 4 שלבים בציר הזמן PH (orders/printer: 4 ב־SM–LG וב־XL+, 3 במובייל–SM וב־LG–XL) */
  isPhTimeline4Steps = false;
  private phTimeline4StepsSub: Subscription;

  constructor(
    public ordersService: OrdersService,
    private authService: AuthService,
    private directionService: DirectionService,
    private usersService: UsersService,
    private router: Router,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private _snackBar: MatSnackBar,
    private branchesService: BranchesService,
    private dataSharingService: DataSharingService,
    private http: HttpClient,
    private israelTimeService: IsraelTimeService,
    private cdr: ChangeDetectorRef,
    private phOrdersService: PHOrdersService,
    private chatService: ChatService,
    private breakpointObserver: BreakpointObserver,
    private commitmentTimeService: CommitmentTimeDisplayService,
    private wallSessionService: WallSessionService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.isLoadOrders = true;

    this.directionSubscription = this.directionService.direction$.subscribe(
      (direction) => {
        this.isRTL = direction === 'rtl';
      }
    );

    this.phTimeline4StepsSub = combineLatest([
      this.breakpointObserver.observe('(min-width: 576px) and (max-width: 991px)').pipe(map((s) => s.matches)),
      this.breakpointObserver.observe('(min-width: 1200px)').pipe(map((s) => s.matches)),
    ])
      .pipe(map(([smLg, xl]) => smLg || xl))
      .subscribe((v) => {
        this.isPhTimeline4Steps = v;
        this.cdr.markForCheck();
      });

    this.directionService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });

    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((isAuthenticated) => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    try {
      const roles = JSON.parse(localStorage.getItem('roles') || '[]');
      this.isSU = Array.isArray(roles) && roles.includes('su');
      this.isBmph = Array.isArray(roles) && roles.includes('bmph');
    } catch {
      this.isSU = false;
      this.isBmph = false;
    }
    this.rolesSub = this.authService.roles$.subscribe((roles) => {
      this.isSU = Array.isArray(roles) && roles.includes('su');
      this.isBmph = Array.isArray(roles) && roles.includes('bmph');
    });

    this.isLoadOrders = true;

    this.route.params.subscribe((params) => {
      if (params['userId']) {
        // console.log('Current URL:', this.router.url);
        const routeUserId = this.normalizeUserId(params['userId']);
        this.fetchUser(routeUserId);
        this.userId = routeUserId;
        this.orderIdFromRoute = params['orderId'] || null;
        this.showOldOrderMessage = false;
        this.isManagementView = this.router.url.includes('userorders');
        this.fetchOrders();
      } else {
        this.fetchUser(localStorage.getItem('userId'));
      }
    });

    // get orders [interval]
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      this.fetchOrders();
    }, 20000);

    this.orderDeletedSub = this.ordersService
      .getOrderDeletedListener()
      .subscribe(() => {
        this.fetchOrders();
      });

    this.priceQuoteSentSuccessSub = this.dialogService.priceQuoteSentSuccess$.subscribe(() => {
      this.isLoadOrders = true;
      this.fetchOrders();
      this.closeAllMenus();
      this.cdr.detectChanges();
    });
    this.productionStartedSuccessSub = this.dialogService.productionStartedSuccess$.subscribe(() => {
      this._snackBar.open(this.translate.instant('chat.production-started-success'), '', { duration: 3000, panelClass: ['auto-width'] });
      this.isLoadOrders = true;
      this.fetchOrders();
      this.closeAllMenus();
    });
    this.productionFinishedSuccessSub = this.dialogService.productionFinishedSuccess$.subscribe(() => {
      this._snackBar.open(this.translate.instant('chat.production-finished-success'), '', { duration: 3000, panelClass: ['auto-width'] });
      this.isLoadOrders = true;
      this.fetchOrders();
      this.closeAllMenus();
      this.cdr.detectChanges();
    });
    this.arrivedAtAddressSuccessSub = this.dialogService.arrivedAtAddressSuccess$.subscribe(() => {
      this._snackBar.open(this.translate.instant('chat.arrived-at-address-success'), '', { duration: 3000, panelClass: ['auto-width'] });
      this.isLoadOrders = true;
      this.fetchOrders();
      this.closeAllMenus();
      this.cdr.detectChanges();
    });
    this.creditOrderSuccessSub = this.dialogService.creditOrderSuccess$.subscribe(() => {
      this._snackBar.open(this.translate.instant('su-management.cancel-order.REFUNDED.success'), '', { duration: 5000, verticalPosition: 'top' });
      this.isLoadOrders = true;
      this.fetchOrders();
      this.closeAllMenus();
      this.cdr.detectChanges();
    });
  }

  fetchOrders() {
    // console.log('isPHOrdered &&&:', this.isPHOrdered);
    let expandedPanelId = this.expandedPanelId;
    const pageSize = this.orderIdFromRoute ? 100 : this.ordersPerPage;
    const page = this.orderIdFromRoute ? 1 : this.currentPage;
    if (this.isManagementView) {
      this.ordersService.getOrdersForSu(
        pageSize,
        page,
        this.userId,
        this.isPHOrdered
      );
    } else {
      this.ordersService.getOrders(
        pageSize,
        page,
        this.userId,
        this.isPHOrdered
      );
    }
    this.ordersSub = this.ordersService
      .getOrderUpdateListener()
      .subscribe((orderData: { orders: any[]; orderCount: number }) => {
        // console.log('isPHOrdered DATA:', orderData);
        let oldOrders = this.unSortedOrders;
        let newOrders = orderData.orders;
        // console.log('isPHOrdered DATA:', orderData);
        oldOrders = oldOrders.map((order) => this.stripOrderShallowForCompare(order));
        newOrders = newOrders.map((order) => this.stripOrderShallowForCompare(order));
        const isEqual = _.isEqual(oldOrders, newOrders);
        if (!isEqual || this.isLoadOrders) {
          const prevOrdersSnapshot = this.orders?.length ? [...this.orders] : [];
          const prevPlotter = this.plotterImageErrors;
          const prevE1 = this.expressImageErrors1;
          const prevE2 = this.expressImageErrors2;

          this.totalOrders = orderData.orderCount;
          this.unSortedOrders = orderData.orders;
          this.sortAndSaveOrders(orderData.orders);
          if (this.orderIdFromRoute) {
            const found = this.orders.find((o) => o._id === this.orderIdFromRoute);
            if (found) {
              this.orders = [found];
              this.showOldOrderMessage = false;
            } else {
              this.orders = [];
              this.showOldOrderMessage = true;
            }
          }
          this.attachExpressMergedUiRows(this.orders);
          this.pruneAllImagesExpandedKeys(
            new Set(this.orders.map((o) => String(o._id)))
          );

          const preserved = this.preserveImageErrorGridsIfPossible(
            prevOrdersSnapshot,
            this.orders,
            prevPlotter,
            prevE1,
            prevE2
          );
          if (preserved) {
            this.plotterImageErrors = preserved.plotter;
            this.expressImageErrors1 = preserved.e1;
            this.expressImageErrors2 = preserved.e2;
          } else {
            this.plotterImageErrors = this.orders.map((order) =>
              !order.is_only_fix_products_in_order && order.files
                ? (order.files || []).map((file) =>
                  new Array((file.images || []).length || 1).fill(false)
                )
                : []
            );
            this.expressImageErrors1 = this.orders.map((order) =>
              !order.is_only_fix_products_in_order && order.files
                ? (order.files || []).map((file) =>
                  new Array((file.images || []).length || 1).fill(false)
                )
                : []
            );
            this.expressImageErrors2 = this.orders.map((order) =>
              !order.is_only_fix_products_in_order && order.files
                ? (order.files || []).map((file) =>
                  new Array((file.images || []).length || 1).fill(false)
                )
                : []
            );
          }
          this.isLoadOrders = false;
          // console.log('new orders updated!', this.orders);
        }
        this.isLoading = false;
        if (expandedPanelId) {
          setTimeout(() => {
            this.expansionPanels.toArray().forEach((panel) => {
              const orderId =
                panel.nativeElement?.getAttribute('data-order-id');
              if (orderId === expandedPanelId) {
                panel.open();
              }
            });
          }, 1000);
        }
      });
  }

  /** For print orders (non-3D) in PENDING: if >14 days since creation, treat as EXPIRED locally */
  private applyLocalExpiredStatus(order: any): void {
    if (order.status !== 'PENDING') return;
    if (this.is3DOrder(order)) return;
    if (this.isEmptyFixProductsPaymentOrder(order)) {
      if (order.status === 'EXPIRED') {
        order.status = 'PENDING';
      }
      return;
    }
    const created = order.created ? new Date(order.created).getTime() : 0;
    const now = this.israelTimeService.getNowTime().getTime();
    const diffHours = (now - created) / (1000 * 60 * 60);
    if (diffHours > 14 * 24) {
      order.status = 'EXPIRED';
    }
  }

  sortAndSaveOrders(preSortedOrders) {
    let sortedOrders = [];
    this.lastPendingOrderIndex = 0;
    if (preSortedOrders && preSortedOrders.length > 0) {
      preSortedOrders.forEach((order) => this.applyLocalExpiredStatus(order));
      preSortedOrders = preSortedOrders.map((order) => this.normalizeOrderForDisplay(order));
      for (let i = 0; i < preSortedOrders.length; i++) {
        if (
          (!preSortedOrders[i].addedToQueue || (preSortedOrders[i].status === 'IN_PRODUCTION' && this.isPHOrder(preSortedOrders[i])) || (preSortedOrders[i].status === 'STARTED_PRODUCTION' && this.isPHOrder(preSortedOrders[i]))) &&
          (preSortedOrders[i].status === 'PENDING' ||
            preSortedOrders[i].status === 'QR' ||
            preSortedOrders[i].status === 'NOT_PAID' ||
            (preSortedOrders[i].status === 'PAID' && this.isPHOrder(preSortedOrders[i])) ||
            (preSortedOrders[i].status === 'IN_QUOTATION' && this.isPHOrder(preSortedOrders[i])) ||
            (preSortedOrders[i].status === 'IN_PRODUCTION' && this.isPHOrder(preSortedOrders[i])) ||
            (preSortedOrders[i].status === 'STARTED_PRODUCTION' && this.isPHOrder(preSortedOrders[i]))) &&
          (!preSortedOrders[i].files || preSortedOrders[i].files.length > 0) &&
          !preSortedOrders[i].isDeleted
        ) {
          sortedOrders.push(preSortedOrders[i]);
          this.lastPendingOrderIndex = this.lastPendingOrderIndex + 1;
        }
      }
      for (let i = 0; i < preSortedOrders.length; i++) {
        if (
          !(
            (!preSortedOrders[i].addedToQueue || (preSortedOrders[i].status === 'IN_PRODUCTION' && this.isPHOrder(preSortedOrders[i])) || (preSortedOrders[i].status === 'STARTED_PRODUCTION' && this.isPHOrder(preSortedOrders[i]))) &&
            (preSortedOrders[i].status === 'PENDING' ||
              preSortedOrders[i].status === 'QR' ||
              preSortedOrders[i].status === 'NOT_PAID' ||
              (preSortedOrders[i].status === 'PAID' && this.isPHOrder(preSortedOrders[i])) ||
              (preSortedOrders[i].status === 'IN_QUOTATION' && this.isPHOrder(preSortedOrders[i])) ||
              (preSortedOrders[i].status === 'IN_PRODUCTION' && this.isPHOrder(preSortedOrders[i])) ||
              (preSortedOrders[i].status === 'STARTED_PRODUCTION' && this.isPHOrder(preSortedOrders[i]))) &&
            (!preSortedOrders[i].files ||
              preSortedOrders[i].files.length > 0) &&
            !preSortedOrders[i].isDeleted
          )
        ) {
          sortedOrders.push(preSortedOrders[i]);
        }
      }
      sortedOrders.forEach((order) => {
        if (this.isPHOrder(order)) {
          order.files.forEach((file) => {
            if (file.settings) {
              file.printSettings = file.settings;
              delete file.settings;
            }
          });
        }
      });
      this.orders = sortedOrders;
      this.checkIfHavePhOrders(this.orders);
    }
  }

  onChangedPage(pageData: PageEvent) {
    this.isLoading = true;
    this.isLoadOrders = true;
    this.currentPage = pageData.pageIndex + 1;
    this.ordersPerPage = pageData.pageSize;
    this.fetchOrders();
  }

  // onDelete(orderId: string) {
  //   this.isLoading = true;
  //   this.ordersService.deleteOrder(orderId).subscribe(() => {
  //     this.ordersService.getOrders(this.ordersPerPage, this.currentPage);
  //   }), () => {
  //     this.isLoading = false;
  //   };
  // }

  // [general]
  roundDownTowDecimal(num: number): number {
    return Math.round(num * 100) / 100;
  }

  // [general]
  private normalizeUserId(userId: any): string {
    if (userId == null) {
      return '';
    }
    if (typeof userId === 'object') {
      return String(userId._id ?? userId.id ?? '').trim();
    }
    const s = String(userId).trim();
    return s === '[object Object]' ? '' : s;
  }

  async fetchUser(userId: string) {
    const id = this.normalizeUserId(userId);
    if (!id) {
      console.error('Error fetching user: invalid userId', userId);
      return;
    }
    try {
      this.user = await this.usersService.getUser(id).toPromise();
      this.isPHOrdered = this.user.isPHOrdered || false;
    } catch (error) {
      console.error('Error fetching user:', error);
    }
    // console.log('USER object is HERE', this.user);
  }

  ngOnDestroy() {
    if (this.ordersSub) {
      this.ordersSub.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.priceQuoteSentSuccessSub) {
      this.priceQuoteSentSuccessSub.unsubscribe();
    }
    if (this.productionStartedSuccessSub) {
      this.productionStartedSuccessSub.unsubscribe();
    }
    if (this.productionFinishedSuccessSub) {
      this.productionFinishedSuccessSub.unsubscribe();
    }
    if (this.arrivedAtAddressSuccessSub) {
      this.arrivedAtAddressSuccessSub.unsubscribe();
    }
    if (this.creditOrderSuccessSub) {
      this.creditOrderSuccessSub.unsubscribe();
    }
    if (this.rolesSub) {
      this.rolesSub.unsubscribe();
    }
    if (this.orderDeletedSub) {
      this.orderDeletedSub.unsubscribe();
    }
    if (this.phTimeline4StepsSub) {
      this.phTimeline4StepsSub.unsubscribe();
    }
  }

  // openOrderSummaryDialog ==========================  -------------------------------------------------------------------------------==========================
  openOrderSummaryDialog(event: Event, order: any): void {
    event.stopPropagation();

    if (order.branchID && !order.branchID.is_express) {
      // [plotter] ---  [plotter] ---  [plotter] --------------------------------------------------------
      if (order.files && order.files.length > 0) {
        // get files and remove proccessing files
        const orderFilesBeforeClean = [...order.files];
        let orderFiles = [];

        orderFilesBeforeClean.forEach((file) => {
          if ((file.images || []).length > 0) {
            orderFiles.push(file);
          }
        });

        let orderFilesData = [];

        for (let i = 0; i < orderFiles.length; i++) {
          const file = orderFiles[i];
          if ((file.images || []).length > 0) {
            const fileData = {
              name: file.fileName,
              originalFileName: file.originalFileName,
              fileId: file._id,
              images: [],
            };
            for (let j = 0; j < file.images.length; j++) {
              const image = file.images[j];
              const paperSerialName = order.printerID.inputBins.find(
                (paper) =>
                  paper.paperType.paperPrinterCode ===
                  image.printSettings.paperType
              ).paperType.paperType;
              const resizeFactor = this.roundDownTowDecimal(
                (image.imageHeight / image.origImageHeight) * 100
              );
              const iamgeData = {
                settings: image.printSettings,
                paperSerialName: paperSerialName,
                width: image.imageWidth,
                height: image.imageHeight,
                resizeFactor: resizeFactor,
                price: image.price,
                path: image.thumbnailPath,
              };
              fileData.images.push(iamgeData);
            }
            orderFilesData.push(fileData);
          }
        }
        // open dialog
        const present = this.user.discount ? 100 - this.user.discount : 100;
        const totalOrderPriceAfterDiscount = order.totalCost * (present / 100);
        // console.log(
        //   'totalOrderPriceAfterDiscount: ',
        //   totalOrderPriceAfterDiscount,
        //   present,
        //   order
        // );
        const serverUrl = order.printerID?.serverAddress
          ? order.printerID.serverAddress
          : '';
        syncIsNotAcademyFromOrder(order, 'plotter');
        this.dialogService.onOpenOrderSummaryDialog(
          'plotter',
          serverUrl,
          [],
          orderFilesData,
          order.branchID.serial_name,
          {
            totalOrderPriceBeforeDiscount: order.totalCost,
            totalOrderPrice: totalOrderPriceAfterDiscount,
            points: this.user.points ? this.user.points : 0,
          },
          this.user,
          true,
          order.adminOrder ? order.adminOrder : false,
          order.branchID.unique,
          order.branchID._id,
          null,
          order._id
        );
        // // [plotter] ---  [plotter] ---  [plotter] --------------------------------------------------------
      }
    } else if (order.branchID && order.branchID.is_express) {
      // [express] ---  [express] ---  [express] --------------------------------------------------------
      if (order.files && order.files.length > 0) {
        // get files and remove proccessing files
        const orderFilesBeforeClean = [...order.files];
        let orderFiles = [];

        orderFilesBeforeClean.forEach((file) => {
          if ((file.images || []).length > 0) {
            orderFiles.push(file);
          }
        });

        let orderFilesData = [];
        // console.log('orderFiles $$$: ', orderFiles);
        // file
        for (let i = 0; i < orderFiles.length; i++) {
          const file = orderFiles[i];
          // remove proccessing files
          if ((file.images || []).length === 0) {
            return;
          }
          // find in this.printServicePapers a paper paper.paperName thet equil to file.printSettings.paperType and save it as paperSerialName
          const paperSerialName = order.printerID.consumables.papers.find(
            (paper) => paper.paperName === file.printSettings.paperType
          ).serial_name;
          const fileData = {
            name: file.fileName,
            originalFileName: file.originalFileName,
            fileId: file._id,
            settings: file.printSettings,
            paperSerialName: paperSerialName,
            images: [],
            price: {
              pricePerPage:
                file.price /
                (file.images.length * file.printSettings.numOfCopies),
              pages: file.images.length,
              copies: file.printSettings.numOfCopies,
            },
          };

          // Get paper width
          let paperType = order.printerID.consumables.papers.find(
            (paper) => paper.paperName === file.printSettings.paperType
          ).paperType;

          let paperWidth = 0;
          let paperHeight = 0;
          if (paperType === 'A4') {
            paperWidth = 21;
            paperHeight = 29.7;
          } else if (paperType === 'A3') {
            paperWidth = 29.7;
            paperHeight = 42;
          } else if (paperType === 'CY-SM') {
            paperWidth = 10.16;
            paperHeight = 15.24;
          } else if (paperType === 'CY-MD') {
            paperWidth = 12.7;
            paperHeight = 17.78;
          } else if (paperType === 'CY-LG') {
            paperWidth = 15.24;
            paperHeight = 20.32;
          }

          // image
          for (let j = 0; j < file.images.length; j++) {
            // if DO fit
            let scaleImageFactor = 1;
            let imageHeight;
            let imageWidth;

            // Calculate if needs to rotate 1
            let BeforeRotationImageWidth =
              (file.images[j].imageWidth / file.images[j].origImageDPI) * 2.54;
            let BeforeRotationImageHeight =
              (file.images[j].imageHeight / file.images[j].origImageDPI) * 2.54;

            if (file.printSettings.fit) {
              // Calculate biddest dims of all images
              let BeforeRotationAllImagesBiggestWidth = file.images.reduce(
                (max, image) => {
                  return Math.max(
                    max,
                    (image.imageWidth / image.origImageDPI) * 2.54
                  );
                },
                0
              );
              let BeforeRotationAllImagesBiggestHeight = file.images.reduce(
                (max, image) => {
                  return Math.max(
                    max,
                    (image.imageHeight / image.origImageDPI) * 2.54
                  );
                },
                0
              );

              const biggerPaperDimm = Math.max(paperWidth, paperHeight);
              const smallerPaperDimm = Math.min(paperWidth, paperHeight);

              let isFitRequired = false;

              // check if original size is possible
              if (
                (biggerPaperDimm > BeforeRotationAllImagesBiggestWidth &&
                  smallerPaperDimm > BeforeRotationAllImagesBiggestHeight) ||
                (biggerPaperDimm > BeforeRotationAllImagesBiggestHeight &&
                  smallerPaperDimm > BeforeRotationAllImagesBiggestWidth)
              ) {
                // original size is possible
                // console.log('original size is possible !!');
                isFitRequired = false;
              } else {
                // original size is NOT possible
                // console.log('original size is NOT possible !!');
                file.printSettings.fit = true;
                file.printSettings.fit = true;
                isFitRequired = true;
              }

              // fit in original size and orientation?
              if (file.printSettings.fit) {
                // do fit
                // console.log('do fit !!');
                let factorIfNotRotater;
                let factorIfRotater;
                // check if original size is possible
                if (
                  BeforeRotationImageWidth / paperWidth >
                  BeforeRotationImageHeight / paperHeight
                ) {
                  factorIfNotRotater = BeforeRotationImageWidth / paperWidth;
                  // console.log("factorIfNotRotater 01", factorIfNotRotater);
                } else {
                  factorIfNotRotater = BeforeRotationImageHeight / paperHeight;
                  // console.log("factorIfNotRotater 02", factorIfNotRotater);
                }
                if (
                  BeforeRotationImageWidth / paperHeight >
                  BeforeRotationImageHeight / paperWidth
                ) {
                  factorIfRotater = BeforeRotationImageWidth / paperHeight;
                  // console.log("factorIfRotater 03", factorIfRotater);
                } else {
                  factorIfRotater = BeforeRotationImageHeight / paperWidth;
                  // console.log("factorIfRotater 04", factorIfRotater);
                }

                if (factorIfRotater < factorIfNotRotater) {
                  // do rotate
                  // console.log('do rotate !!');
                  // --- this.isCurrentrotated = true;
                  const AfretRotationImageWidth = BeforeRotationImageHeight;
                  const AfretRotationImageHeight = BeforeRotationImageWidth;
                  if (
                    paperWidth / AfretRotationImageWidth <
                    paperHeight / AfretRotationImageHeight
                  ) {
                    // fit to width
                    // console.log('fit to width !!');
                    scaleImageFactor = paperWidth / AfretRotationImageWidth;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  } else {
                    // fit to height
                    // console.log('fit to height !!');
                    scaleImageFactor = paperHeight / AfretRotationImageHeight;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  }
                } else {
                  // dont rotate
                  // console.log('dont rotate !!');
                  // --- this.isCurrentrotated = false;
                  const AfretRotationImageWidth = BeforeRotationImageWidth;
                  const AfretRotationImageHeight = BeforeRotationImageHeight;
                  if (
                    paperWidth / AfretRotationImageWidth <
                    paperHeight / AfretRotationImageHeight
                  ) {
                    // fit to width
                    // console.log('fit to width !!');
                    scaleImageFactor = paperWidth / AfretRotationImageWidth;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  } else {
                    // fit to height
                    // console.log('fit to height !!');
                    scaleImageFactor = paperHeight / AfretRotationImageHeight;
                    imageHeight = AfretRotationImageHeight * scaleImageFactor;
                    imageWidth = AfretRotationImageWidth * scaleImageFactor;
                  }
                }
              }
            } else {
              // dont fit
              // console.log('dont fit !!');
              if (
                paperWidth > BeforeRotationImageWidth &&
                paperHeight > BeforeRotationImageHeight
              ) {
                // do fit in original size and orientation
                // console.log('do fit in original size and orientation');
                // this.isCurrentrotated = false;
                imageHeight = BeforeRotationImageHeight;
                imageWidth = BeforeRotationImageWidth;
              } else {
                // doesnt fit in original size and orientation
                // console.log('doesnt fit in original size and orientation');
                // this.isCurrentrotated = true;
                imageHeight = BeforeRotationImageWidth;
                imageWidth = BeforeRotationImageHeight;
              }
            }

            const image = file.images[j];
            const imageData = {
              index: j,
              width: this.roundDownTowDecimal(imageWidth),
              height: this.roundDownTowDecimal(imageHeight),
              scaleFactor: this.roundDownTowDecimal(scaleImageFactor * 100),
              path:
                this.expressServerAdress +
                '/uploads/' +
                this.getUserNameForFile(file) +
                '/' +
                image.thumbnailPath.split('/').pop(),
            };
            // console.log('imageData ::::: ', imageData);
            fileData.images.push(imageData);
          }
          // console.log('fileData ::::: ', fileData);
          orderFilesData.push(fileData);
        }
        // open dialog
        const present = this.user.discount ? 100 - this.user.discount : 100;
        const totalOrderPriceAfterDiscount = order.totalCost * (present / 100);
        const printerId = order.printerID?._id || order.printerID?.id || order.printerID?.unique || '';
        syncIsNotAcademyFromOrder(order, 'express');
        this.dialogService.onOpenOrderSummaryDialog(
          'express',
          this.expressServerAdress,
          [],
          orderFilesData,
          order.printerID.serial_name,
          {
            totalOrderPriceBeforeDiscount: order.totalCost,
            totalOrderPrice: totalOrderPriceAfterDiscount,
            points: this.user.points ? this.user.points : 0,
          },
          this.user,
          true,
          order.adminOrder ? order.adminOrder : false,
          order.printerID.unique,
          '',
          printerId,
          order._id,
          null,
          null,
          order.printerID.isPicsPrinter ? order.printerID.isPicsPrinter : false
        );
      }
      // // [express] ---  [express] ---  [express] --------------------------------------------------------
    }
  }

  // openDeleteOrderDialog ==========================  -------------------------------------------------------------------------------==========================
  openDeleteOrderDialog(event: Event, order: any): void {
    event.stopPropagation();
    if (this.isPHOrder(order) && !this.isManagementView && !this.canUserCancelPhOrder(order)) {
      return;
    }
    this.closeAllMenus();
    const orderType = this.isPHOrder(order) ? 'ph' : undefined;
    this.dialogService.onOpenDeleteOrderDialog(order, this.isManagementView, orderType);
  }
  // openDeleteOrderDialog ==========================  -------------------------------------------------------------------------------==========================

  // [general]
  getUserName() {
    return localStorage.getItem('userName');
  }

  // Get userName for file - use originalUserName if file was transferred
  getUserNameForFile(file: any): string {
    if (file && file.originalUserName && file.originalUserName.trim() !== '') {
      return file.originalUserName;
    }
    return this.getUserName();
  }

  getUserId() {
    return localStorage.getItem('userId');
  }

  /** מזהה המשתמש לנתיב צ'אט משתמש – תמיד המשתמש המחובר (נדרש ל-checkAuthPrivate בבאק) */
  get userChatUserId(): string {
    return this.authService.getUserId() || this.userId || '';
  }

  addSecondsToDate(sentDate: string, numOfFiles: number): Date {
    // Convert sentDate string to Date object
    let date = new Date(sentDate);
    // Convert numOfFiles to milliseconds (since 1 second = 1000 milliseconds)
    let additionalTime = numOfFiles * 25 * 1000;
    // Create a new Date object from sentDate
    let newDate = new Date(date.getTime());
    // Add the additional time to the new date
    newDate.setTime(newDate.getTime() + additionalTime);
    return newDate;
  }

  goToNewOrder() {
    const printingService = localStorage.getItem('printingService');
    const branch = localStorage.getItem('branch');
    if (
      printingService &&
      printingService !== 'null' &&
      printingService !== '' &&
      branch &&
      branch !== 'null' &&
      branch !== ''
    ) {
      this.dialogService.onOpenRightPlaceDialog();
    } else if (branch && branch !== 'null' && branch !== '') {
      this.router.navigate(['/branch']);
    } else {
      this.router.navigate(['/']);
    }
  }

  /** ניווט לעמוד הצ'אט של ההזמנה – משתמש או מנהל (לפי isManagementView) */
  navigateToChat(order: any): void {
    if (!order?._id) return;
    if (this.isManagementView) {
      this.router.navigate(['/chat/manager', order._id]);
    } else {
      // לנתיב user – להעביר תמיד את מזהה המשתמש המחובר (נדרש ל-checkAuthPrivate בבאק)
      const loggedInUserId = this.authService.getUserId() || this.userId;
      if (loggedInUserId) {
        this.router.navigate(['/chat/user', loggedInUserId, order._id]);
      }
    }
  }

  togglePanel(order: any): void {
    if (this.isEmptyFixProductsPaymentOrder(order)) {
      this.expandedPanelId = this.expandedPanelId === order._id ? null : order._id;
      return;
    }

    // Find the index of the order that is being opened
    const index = this.orders.findIndex((o) => o._id === order._id);

    // Get the panel and the container
    const panel = this.expansionPanels.toArray()[index];
    const container = this.scrollContainer;

    // Ensure that both the panel and the container are defined
    if (panel && container && container.nativeElement) {
      // Expand or collapse the MatExpansionPanel
      if (this.expandedPanelId === order._id) {
        panel.close();
        this.expandedPanelId = null;
      } else {
        panel.open();
        this.expandedPanelId = order._id;

        // Listen for the afterExpand event of the MatExpansionPanel
        const subscription = panel.afterExpand.subscribe(() => {
          // Scroll the container down by 50px
          container.nativeElement.scrollBy({
            top: 5,
            behavior: 'smooth',
          });

          // Unsubscribe from the afterExpand event to avoid memory leaks
          subscription.unsubscribe();
        });
      }
    }
  }

  getPaperSerialName(paperCode: string, inputBins: any[]): string {
    if (!paperCode || !inputBins || inputBins.length === 0) {
      return null;
    }
    if (
      inputBins.find(
        (paper) => paper?.paperType?.paperPrinterCode === paperCode
      )?.paperType?.paperType
    ) {
      const paperSerialName = inputBins.find(
        (paper) => paper.paperType.paperPrinterCode === paperCode
      ).paperType.paperType;
      return paperSerialName;
    } else {
      return null;
    }
  }

  getPaperSerialNameExpress(paperType: string, papers: any[]): string {
    if (!paperType || !papers || papers.length === 0) {
      return null;
    }
    if (papers.find((paper) => paper.paperName === paperType)) {
      const paper = papers.find((paper) => paper.paperName === paperType);
      return paper.serial_name;
    } else {
      return null;
    }
  }

  /** מפתח תרגום: מצב rasterized מ־file.complexity (אקספרס 2D). */
  getExpressFileRasterizedLabelKey(file: any): string {
    const r = file?.complexity?.rasterized;
    if (r === true) {
      return "printing-table.express-rasterized-yes";
    }
    if (r === false) {
      return "printing-table.express-rasterized-no";
    }
    return "printing-table.express-rasterized-unknown";
  }

  isAllFilesHavePaperSet(order) {
    if (this.isPHOrder(order) || this.isEmptyFixProductsPaymentOrder(order)) return true;
    if (!order?.branchID) return true;
    let isOrderAllFilesHavePaperSet = true;
    if (!order.branchID.is_express) {
      // [plotter]
      // console.log("---- plotter");
      for (let file of order.files) {
        for (let image of file.images) {
          let paperCode = image.printSettings.paperType;
          let paperExists = order.printerID.inputBins.find(
            (paper) => paper.paperType.paperPrinterCode === paperCode
          );
          // console.log("paperExists", paperExists)
          if (!paperExists) {
            isOrderAllFilesHavePaperSet = false;
            break;
          }
        }
        if (!isOrderAllFilesHavePaperSet) {
          break;
        }
      }
    } else {
      // [express]
      // console.log("---- express");
      if (!order.is_only_fix_products_in_order) {
        for (let file of order.files) {
          let paperType = file.printSettings.paperType;
          if (order.printerID?.consumables?.papers) {
            let paperExists = order.printerID.consumables.papers.find(
              (paper) => paper.paperName === paperType
            );
            // console.log("paperExists", paperExists)
            if (!paperExists) {
              isOrderAllFilesHavePaperSet = false;
              break;
            }
          }
        }
      }
    }
    // console.log("isOrderAllFilesHavePaperSet", isOrderAllFilesHavePaperSet)
    return isOrderAllFilesHavePaperSet;
  }

  getExpressDimensions(
    direction: string,
    imageWidth: number,
    imageHeight: number,
    printSettings: any,
    branchPapers: any[],
    dpi: number
  ) {
    if (!dpi) return 0;
    const papers = branchPapers || [];
    // console.log('getExpressDimensions:', direction, imageWidth, imageHeight, printSettings, branchPapers);
    let imageWidthInCm = (imageWidth / dpi) * 2.54;
    let imageHeightInCm = (imageHeight / dpi) * 2.54;
    let imageScaleFactor = 1;
    if (printSettings.fit) {
      let paperWidth = 0;
      let paperHeight = 0;

      // Get paper width
      const matched = printSettings ? papers.find(
        (paper) => paper.paperName === printSettings.paperType
      ) : null;
      if (matched?.serial_name) {
        const paperCode = matched.serial_name;
        if (paperCode === 'A4') {
          paperWidth = 21;
          paperHeight = 29.7;
        } else if (paperCode === 'A3') {
          paperWidth = 29.7;
          paperHeight = 42;
        } else if (paperCode === 'A4160') {
          paperWidth = 21;
          paperHeight = 29.7;
        } else if (paperCode === 'A3160') {
          paperWidth = 29.7;
          paperHeight = 42;
        } else if (paperCode === 'A4Recycled') {
          paperWidth = 21;
          paperHeight = 29.7;
        } else if (paperCode === 'SM') {
          paperWidth = 10.16;
          paperHeight = 15.24;
        } else if (paperCode === 'MD') {
          paperWidth = 12.7;
          paperHeight = 17.78;
        } else if (paperCode === 'LG') {
          paperWidth = 15.24;
          paperHeight = 20.32;
        }
      }

      let factorIfNotRotater;
      let factorIfRotater;
      if (imageWidthInCm / paperWidth > imageHeightInCm / paperHeight) {
        factorIfNotRotater = imageWidthInCm / paperWidth;
        // console.log("factorIfNotRotater 01", factorIfNotRotater);
      } else {
        factorIfNotRotater = imageHeightInCm / paperHeight;
        // console.log("factorIfNotRotater 02", factorIfNotRotater);
      }
      if (imageWidthInCm / paperHeight > imageHeightInCm / paperWidth) {
        factorIfRotater = imageWidthInCm / paperHeight;
        // console.log("factorIfRotater 03", factorIfRotater);
      } else {
        factorIfRotater = imageHeightInCm / paperWidth;
        // console.log("factorIfRotater 04", factorIfRotater);
      }
      if (factorIfRotater < factorIfNotRotater) {
        imageScaleFactor = factorIfRotater;
      } else {
        imageScaleFactor = factorIfNotRotater;
      }
    }
    if (direction === 'h') {
      return this.roundDownTowDecimal(imageHeightInCm / imageScaleFactor);
    } else if (direction === 'w') {
      return this.roundDownTowDecimal(imageWidthInCm / imageScaleFactor);
    }
    return null;
  }

  openWhatsApp(type: string = "") {
    let message;
    if (type === 'ph') {
      message = encodeURIComponent('Smart-Printing-Center-Orders-at-Eazix');
    } else {
      message = encodeURIComponent('Hi Eazix, I need some help printing :)');
    }
    const phoneNumber = '97233746962';
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(url, '_blank');
  }

  handleImageError(event: ErrorEvent, i: number) {
    this.expressImageErrors1[i] = true;
  }

  allImagesRowKey(order: any, file: any, fileIndexInLoop: number): string {
    const oid = order?._id != null ? String(order._id) : '';
    if (file?._isChunkedMerged) {
      return `${oid}:chunked:${file._chunkGroupKey ?? file._id ?? fileIndexInLoop}`;
    }
    const fid = file?._id != null ? String(file._id) : `f${fileIndexInLoop}`;
    const sfi = file?._sourceFileIndex;
    const spi = file?._sourcePageIndex;
    if (sfi != null || spi != null) {
      return `${oid}:${fid}:${sfi ?? ''}:${spi ?? ''}`;
    }
    return `${oid}:${fid}`;
  }

  isAllImagesExpanded(order: any, file: any, fileIndexInLoop: number): boolean {
    return this.allImagesExpandedKeys.has(
      this.allImagesRowKey(order, file, fileIndexInLoop)
    );
  }

  showMoreImagesFor(order: any, file: any, fileIndexInLoop: number): void {
    this.allImagesExpandedKeys.add(
      this.allImagesRowKey(order, file, fileIndexInLoop)
    );
  }

  hideMoreImagesFor(order: any, file: any, fileIndexInLoop: number): void {
    this.allImagesExpandedKeys.delete(
      this.allImagesRowKey(order, file, fileIndexInLoop)
    );
  }

  private pruneAllImagesExpandedKeys(validOrderIds: Set<string>): void {
    for (const key of this.allImagesExpandedKeys) {
      const oid = key.split(':')[0];
      if (!validOrderIds.has(oid)) {
        this.allImagesExpandedKeys.delete(key);
      }
    }
  }

  private stripOrderShallowForCompare(order: any): any {
    if (!order) {
      return order;
    }
    return _.omit(order, [
      'updatedAt',
      '__v',
      'modifiedAt',
      'userID',
      'printerID',
      'branchID',
    ]);
  }

  private preserveImageErrorGridsIfPossible(
    prevOrders: any[] | undefined,
    nextOrders: any[],
    prevPlotter: any,
    prevE1: any,
    prevE2: any
  ): { plotter: any; e1: any; e2: any } | null {
    if (!prevOrders?.length || !nextOrders?.length) {
      return null;
    }
    if (prevOrders.length !== nextOrders.length) {
      return null;
    }
    for (let o = 0; o < nextOrders.length; o++) {
      if (prevOrders[o]?._id !== nextOrders[o]?._id) {
        return null;
      }
      const pf = prevOrders[o]?.files || [];
      const nf = nextOrders[o]?.files || [];
      if (pf.length !== nf.length) {
        return null;
      }
      for (let f = 0; f < nf.length; f++) {
        if (pf[f]?._id !== nf[f]?._id) {
          return null;
        }
        if ((pf[f]?.images?.length ?? 0) !== (nf[f]?.images?.length ?? 0)) {
          return null;
        }
      }
    }
    if (!prevPlotter || !prevE1 || !prevE2) {
      return null;
    }
    if (
      prevPlotter.length !== nextOrders.length ||
      prevE1.length !== nextOrders.length ||
      prevE2.length !== nextOrders.length
    ) {
      return null;
    }
    return { plotter: prevPlotter, e1: prevE1, e2: prevE2 };
  }

  // [plotter]
  // getImgPlotter(order, fileIndex, imgIndex) {
  //   // === OLD & NEW ===
  //   const thumbnail = order.files[fileIndex].images[imgIndex].thumbnailPath;
  //   const isNewThumbnail = thumbnail.startsWith("/home/ubuntu/IMG-Plotter");
  //   let newThumbnail = '';
  //   if (isNewThumbnail) {
  //     const serverAddress = order.printerID?.serverAddress ? order.printerID.serverAddress : '';
  //     const shortThumbnail = thumbnail.replace('/home/ubuntu/IMG-Plotter', '');
  //     newThumbnail = serverAddress + shortThumbnail;
  //   } else {
  //     newThumbnail = thumbnail;
  //   }
  //   return newThumbnail;
  // }

  // [plotter]
  getImgPlotter(order: any, fileIndex: number, imgIndex: number) {
    const image = order?.files?.[fileIndex]?.images?.[imgIndex];
    const thumbnail = image?.thumbnailPath;
    if (!thumbnail) {
      return '';
    }
    const cacheKey = [
      String(order?._id ?? ''),
      String(fileIndex),
      String(imgIndex),
      String(thumbnail),
      String(order?.printerID?.serverAddress ?? ''),
    ].join('\x1e');
    if (
      image.__cachedPlotterImgKey === cacheKey &&
      typeof image.__cachedPlotterImgUrl === 'string'
    ) {
      return image.__cachedPlotterImgUrl;
    }
    const isNewThumbnail =
      thumbnail.startsWith('uploads') ||
      thumbnail.startsWith('/home/ubuntu/IMG-Plotter');
    let newThumbnail = '';
    if (isNewThumbnail) {
      const serverAddress = order.printerID?.serverAddress
        ? order.printerID.serverAddress
        : '';
      if (thumbnail.startsWith('uploads')) {
        newThumbnail = serverAddress + '/' + thumbnail;
      } else {
        const shortThumbnail = thumbnail.replace(
          '/home/ubuntu/IMG-Plotter',
          ''
        );
        newThumbnail = serverAddress + shortThumbnail;
      }
    } else {
      newThumbnail = thumbnail;
    }
    image.__cachedPlotterImgKey = cacheKey;
    image.__cachedPlotterImgUrl = newThumbnail;
    return newThumbnail;
  }

  private expressThumbnailCacheKey(order: any, image: any): string {
    return [
      String(order?._id ?? ''),
      String(order?.status ?? ''),
      String(order?.user ?? ''),
      String(order?.branchID?.serial_name ?? ''),
      String(image?.thumbnailPath ?? ''),
      String(image?.path ?? ''),
      String(image?._id ?? ''),
      this.expressServerAdress,
    ].join('\x1e');
  }

  /** מטמון על אובייקט התמונה — אותו URL כל עוד המפתח לא השתנה */
  getImgExpress(order: any, image: any): string {
    if (!order || !image) {
      return '/assets/images/box-icon.svg';
    }
    const cacheKey = this.expressThumbnailCacheKey(order, image);
    if (
      image.__cachedExpressImgKey === cacheKey &&
      typeof image.__cachedExpressImgUrl === 'string'
    ) {
      return image.__cachedExpressImgUrl;
    }
    let newThumbnail = '';
    if (image.path && (image.path.startsWith('/assets/') || image.path.startsWith('assets/'))) {
      newThumbnail = image.path.startsWith('/') ? image.path : '/' + image.path;
      image.__cachedExpressImgKey = cacheKey;
      image.__cachedExpressImgUrl = newThumbnail;
      return newThumbnail;
    }
    if (!order.branchID?.serial_name) {
      newThumbnail = image.path || image.thumbnailPath || '/assets/images/box-icon.svg';
      image.__cachedExpressImgKey = cacheKey;
      image.__cachedExpressImgUrl = newThumbnail;
      return newThumbnail;
    }
    const isNewThumbnail = image.thumbnailPath?.startsWith('/home/ubuntu/IMG-Express');
    if (isNewThumbnail && !this.isPHOrder(order)) {
      newThumbnail = image.thumbnailPath.replace(
        '/home/ubuntu/IMG-Express',
        this.expressServerAdress
      );
    } else {
      if (
        order.status === 'PENDING' ||
        order.status === 'QR' ||
        order.status === 'NOT_PAID'
      ) {
        const thumbPath = image.thumbnailPath || '';
        const fileName = thumbPath ? thumbPath.split(/[/\\]/).pop() : '';
        newThumbnail = fileName && order.branchID?.serial_name
          ? 'https://' + order.branchID.serial_name + '.eazix.io/uploads/' + (order.user || '') + '/' + fileName
          : (image.path || image.thumbnailPath || '/assets/images/box-icon.svg');
      } else {
        newThumbnail = !this.isPHOrder(order)
          ? (image.thumbnailPath || image.path)
          : (image.path || image.thumbnailPath);
      }
    }
    const out = newThumbnail || '/assets/images/box-icon.svg';
    image.__cachedExpressImgKey = cacheKey;
    image.__cachedExpressImgUrl = out;
    return out;
  }

  getIsPics(printer: any) {
    if (printer && printer.isPicsPrinter) {
      return 'pics';
    } else {
      return 'express';
    }
  }

  getOrderFixProductsPrice(order: any): number {
    let fixProductsPrice = 0;
    if (order.fix_products_order?.totalCost) {
      fixProductsPrice = order.fix_products_order.totalCost;
    }
    return fixProductsPrice;
  }

  getAmountOfFixProducts(products: any): number {
    let amount = 0;
    for (let i = 0; i < products.length; i++) {
      amount += products[i].quantity;
    }
    return amount;
  }

  openPreviewDialogInner(
    service: string,
    order: any,
    file: any,
    imgIndex: number,
    sourceFile?: any
  ) {
    let realService = service === 'express' ? (this.isPHOrder(order) ? 'ph' : 'express') : service;
    const previewFile = sourceFile ?? file;
    // image
    // בשורת אקספרס מפוצלת (_splitExpressMerged) — תמיד תמונה יחידה באינדקס 0
    const effectiveIndex = previewFile._splitExpressMerged ? 0 : imgIndex;
    const image = previewFile.images?.[effectiveIndex] ? previewFile.images[effectiveIndex] : null;
    if (!image) {
      return;
    }
    // selectedPaper
    let selectedPaper = null;
    if (realService === 'plotter') {
      selectedPaper = order.printerID.inputBins.find(
        (paper) =>
          paper.paperType.paperPrinterCode === image.printSettings.paperType
      );
    } else if (realService === 'express') {
      selectedPaper = order.printerID.consumables.papers.find(
        (paper) => paper.paperName === previewFile.printSettings.paperType
      );
    } else if (realService === 'ph') {
      selectedPaper = order.productID?.types.find(
        (type) => type.name === previewFile.printSettings.paperType
      );
    }

    if (!selectedPaper) {
      return;
    }
    // selectedPaper
    let cropRatioValue = true;
    if (service === 'express') {
      cropRatioValue = previewFile.printSettings.cropRatio
        ? previewFile.printSettings.cropRatio
        : true;
    }
    // status
    const orderStatus = order.status ? order.status : null;
    // open dialog
    this.dialogService.onOpenImagePreviewDialog(
      service,
      previewFile,
      image,
      order.printerID,
      selectedPaper,
      cropRatioValue,
      false,
      orderStatus
    );
  }

  //  ======================== MANIGMENT MODE ========================
  goToOrdersManagement() {
    const service = localStorage.getItem('searchedService');
    localStorage.removeItem('searchedService');
    const branch = localStorage.getItem('searchedBranchId');
    localStorage.removeItem('searchedBranchId');
    this.router.navigate([`/printer/${service}/${branch}`], {
      queryParams: { q: 'orders' },
    });
  }

  goToUsersManagementOnUser() {
    const service = localStorage.getItem('searchedService');
    localStorage.removeItem('searchedService');
    const branch = localStorage.getItem('searchedBranchId');
    localStorage.removeItem('searchedBranchId');
    this.router.navigate([`/printer/${service}/${branch}`], {
      queryParams: { q: 'users', user: this.user.email },
    });
  }

  goToAllUserOrders() {
    this.router.navigate(['/userorders', this.userId]);
  }

  /** אקספרס — קובץ מעובד שלא נשלח: מ־processedFilePath (פיצול merged ב־" | ") */
  private buildExpressProcessedNotSentUrl(file: any): string | null {
    const raw = file?.processedFilePath;
    if (typeof raw !== 'string' || !raw.trim()) {
      return null;
    }
    const parts = raw.split(/\s*\|\s*/).map((s) => s.trim()).filter(Boolean);
    if (parts.length === 0) {
      return null;
    }
    const idx =
      parts.length > 1 &&
      file?._splitExpressMerged &&
      file._sourcePageIndex != null
        ? file._sourcePageIndex
        : 0;
    const fullPath = parts[idx] ?? parts[0];
    const relative = String(fullPath)
      .replace('/home/ubuntu/IMG-Express/', '')
      .replace(/^\/+/, '');
    return this.expressServerAdress + '/' + relative;
  }

  onDownloadOriginalFile(
    service: string,
    imgIndex: number,
    file: any,
    order: any,
    isOriginal: boolean | 'processedNotSent' = true
  ) {
    if (!this.isManagementView) {
      return;
    }
    if (isOriginal === false && order?.status === 'PENDING') {
      return;
    }
    const created = file.created;
    const now = this.israelTimeService.getNowTime();
    const diffInSeconds = Math.floor(
      (now.getTime() - new Date(created).getTime()) / 1000
    );
    const twoWeeksSeconds = 14 * 24 * 3600;
    // Express (unchanged): 14d for original + processed-not-sent only; printed PDF unlimited. PH uses getOrderFilesSystem() → 'express', never 'plotter'.
    const isExpressDownloadExpired =
      service === 'express' &&
      (isOriginal === true || isOriginal === 'processedNotSent') &&
      diffInSeconds > twoWeeksSeconds;
    // Plotter only: 14d for every download type (original + resized sent to print). Applies to every file in bulk menu too.
    const isPlotterDownloadExpired =
      service === 'plotter' &&
      diffInSeconds > twoWeeksSeconds;
    if (isExpressDownloadExpired || isPlotterDownloadExpired) {
      this._snackBar.open(
        this.translate.instant('my-orders.order-expired') +
        ' - ' +
        this.translate.instant('my-orders.order-expired-explain'),
        '',
        {
          duration: 5000,
          panelClass: ['auto-width', 'center-text'].filter(Boolean),
        }
      );
      return;
    }
    let path = '';
    let fileType = '';
    if (service === 'plotter') {
      const serverAddress = order.printerID?.serverAddress
        ? order.printerID.serverAddress
        : '';
      let img = '';
      if (isOriginal === true) {
        img = (file.filePath && file.fileName) ? file.filePath + '/' + file.fileName : "";
        fileType = 'jpg';
      } else {
        img = file.images[imgIndex].resizedPath ? file.images[imgIndex].resizedPath : "";
        fileType = 'jpg';
      };
      const modifiedImg = img.replace('/home/ubuntu/IMG-Plotter/', '');
      path = serverAddress + '/' + modifiedImg;
    } else if (service === 'express') {
      if (isOriginal === true) {
        if (file.originalFilePath) {
          const relative = String(file.originalFilePath).replace(
            '/home/ubuntu/IMG-Express/',
            ''
          );
          path =
            this.expressServerAdress +
            '/' +
            relative.replace(/^\/+/, '');
        } else {
          const username = order?.user || '';
          path =
            this.expressServerAdress +
            '/uploads/' +
            username +
            '/originals/' +
            file.fileName;
        }
        const nameForType = file.fileName || path.split('/').pop();
        fileType = nameForType ? String(nameForType).split('.').pop() : '';
      } else if (isOriginal === 'processedNotSent') {
        path = this.buildExpressProcessedNotSentUrl(file) || '';
        if (!path) {
          const modifiedImg = (file.filePath || '')
            .replace('/home/ubuntu/IMG-Express/', '')
            .replace(/^\/+/, '');
          path =
            this.expressServerAdress +
            '/' +
            modifiedImg +
            '/' +
            String(file?.fileName || '');
        }
        const tail = path.split('/').pop() || '';
        fileType = tail.includes('.') ? tail.split('.').pop() || '' : '';
      } else {
        path = file.pdfPath;
        fileType = 'pdf';
      }
    }
    if (path) {
      const fileName = path.split('/').pop();
      console.log('[order file download] source URL:', path);
      fetch(path)
        .then((response) => {
          if (!response.ok) {
            this._snackBar.open(
              this.translate.instant('su-management.users.download-error'),
              '',
              {
                duration: 4000,
                panelClass: ['auto-width', 'center-text'].filter(Boolean),
              }
            );
            throw new Error('File not found');
          }
          return response.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error(
            'Error downloading file with fetch, trying direct download:',
            error
          );
          const link = document.createElement('a');
          link.href = path;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    }
  }

  /** SU / BMPH במצב צפייה בהזמנות משתמש – הורדת קבצי 3D */
  canDownload3DOrderFiles(): boolean {
    return this.isManagementView && (this.isSU || this.isBmph);
  }

  private get3DFileDownloadUrl(file: any): string | null {
    if (!file) {
      return null;
    }
    const url =
      file.fileUrl ||
      file.FileUrl ||
      file.url ||
      file.settings?.fileUrl ||
      file.settings?.FileUrl ||
      file.printSettings?.fileUrl ||
      file.printSettings?.FileUrl;
    if (typeof url !== 'string' || !url.trim()) {
      return null;
    }
    if (url.includes('box-icon') || url.includes('assets/') || url.endsWith('.svg')) {
      return null;
    }
    return url;
  }

  private download3DFileByFileId(fileId: string, fileName: string) {
    const base = (environment.apiUrl || '').replace(/\/+$/, '');
    const url = `${base}/files/download3dprintfile/${fileId}`;
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = (fileName || 'file.stl').trim();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
      },
      error: () => {
        this._snackBar.open(
          this.translate.instant('su-management.users.download-error'),
          '',
          { duration: 4000, panelClass: ['auto-width', 'center-text'].filter(Boolean) }
        );
      },
    });
  }

  /** הורדת קובץ 3D – ישירות מ-fileUrl או דרך API (כמו בצ'אט) */
  onDownload3DFile(file: any) {
    if (!this.canDownload3DOrderFiles()) {
      return;
    }
    const url = this.get3DFileDownloadUrl(file);
    const fileId = file?.fileId || file?._id;
    const fileName = (file?.fileName || file?.name || file?.originalFileName || 'file.stl').trim();
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }
    if (fileId) {
      this.download3DFileByFileId(String(fileId), fileName);
    }
  }

  /** הורדת כל קבצי 3D בהזמנה */
  onDownloadAll3DFiles(order: any) {
    if (!this.canDownload3DOrderFiles() || !order?.files?.length) {
      return;
    }
    order.files.forEach((file: any, i: number) => {
      const url = this.get3DFileDownloadUrl(file);
      const fileId = file?.fileId || file?._id;
      if (url || fileId) {
        setTimeout(() => this.onDownload3DFile(file), i * 500);
      }
    });
    this.closeAllMenus();
  }

  onDownloadExpressUiFile(
    file: any,
    order: any,
    isOriginal: boolean | 'processedNotSent' = true
  ) {
    if (
      file?._isChunkedMerged &&
      file._chunkedSourceParts?.length &&
      (isOriginal === 'processedNotSent' || isOriginal === false)
    ) {
      let n = 0;
      for (const part of file._chunkedSourceParts) {
        if (part.f?.images?.length > 0) {
          setTimeout(() => {
            this.onDownloadOriginalFile('express', 0, part.f, order, isOriginal);
          }, n * 1000);
          n++;
        }
      }
      this.closeAllMenus();
      return;
    }
    this.onDownloadOriginalFile('express', 0, file, order, isOriginal);
  }

  onDownloadOrderOriginalFiles(
    service: string,
    order: any,
    isOriginal: boolean | 'processedNotSent' = true
  ) {
    if (!order.files?.length) {
      this.closeAllMenus();
      return;
    }
    let n = 0;
    if (service === 'express') {
      const filesToDownload =
        Array.isArray(order.expressFilesUi) && order.expressFilesUi.length > 0
          ? order.expressFilesUi
          : order.files;
      for (let k = 0; k < filesToDownload.length; k++) {
        const file = filesToDownload[k];
        if (file._isChunkedMerged && file._chunkedSourceParts?.length) {
          if (isOriginal === 'processedNotSent' || isOriginal === false) {
            for (const part of file._chunkedSourceParts) {
              if (part.f?.images?.length > 0) {
                setTimeout(() => {
                  this.onDownloadOriginalFile(service, 0, part.f, order, isOriginal);
                }, n * 1000);
                n++;
              }
            }
          } else if (file.images?.length > 0) {
            setTimeout(() => {
              this.onDownloadOriginalFile(service, 0, file, order, isOriginal);
            }, n * 1000);
            n++;
          }
        } else if (file.images?.length > 0) {
          setTimeout(() => {
            this.onDownloadOriginalFile(service, 0, file, order, isOriginal);
          }, n * 1000);
          n++;
        }
      }
    } else {
      for (let i = 0; i < order.files.length; i++) {
        const file = order.files[i];
        if (service === 'plotter') {
          const fileType = file.fileType === "application/pdf" ? 'pdf' : 'jpg';
          if (fileType !== 'pdf' && file.images.length > 0) {
            for (let j = 0; j < file.images.length; j++) {
              setTimeout(() => {
                this.onDownloadOriginalFile(service, j, file, order, isOriginal as boolean);
              }, n * 1000);
              n++;
            }
          } else {
            setTimeout(() => {
              this.onDownloadOriginalFile(service, 0, file, order, isOriginal as boolean);
            }, n * 1000);
            n++;
          }
        }
      }
    }
    this.closeAllMenus();
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }

  get isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  hasPlotterPaperUsage(order: any): boolean {
    return hasPlotterPaperUsage(order);
  }

  getPlotterPaperUsageTooltip(order: any): string {
    return buildPlotterPaperUsageTooltip(order, this.translate);
  }

  resolveTargetUserEmailForSms(order: any): string {
    if (this.isManagementView && this.user?.email) {
      return String(this.user.email).trim();
    }
    if (!order) {
      return '';
    }
    const uid = order.userID;
    if (uid && typeof uid === 'object' && uid.email) {
      return String(uid.email).trim();
    }
    if (order.userEmail) {
      return String(order.userEmail).trim();
    }
    const u = order.user;
    if (typeof u === 'string' && u.includes('@')) {
      return u.trim();
    }
    return '';
  }

  /** טלפון על ההזמנה, נטען מהמשתמש (`order.userID.phone`) ולא מהזמנה עצמה. */
  getOrderPhone(order: any): any {
    const uid = order?.userID;
    if (uid && typeof uid === 'object' && uid.phone != null) {
      return uid.phone;
    }
    const u = order?.user;
    if (u && typeof u === 'object' && u.phone != null) {
      return u.phone;
    }
    return null;
  }

  /** טלפון לשליחת SMS: על ההזמנה או — במצב מנהל — טלפון בפרופיל המשתמש המוצג. */
  orderHasPhoneForSms(order: any): boolean {
    if (this.hasMeaningfulPhoneValue(this.getOrderPhone(order))) {
      return true;
    }
    if (this.isManagementView && this.hasMeaningfulPhoneValue(this.user?.phone)) {
      return true;
    }
    return false;
  }

  private hasMeaningfulPhoneValue(value: any): boolean {
    if (value == null) {
      return false;
    }
    const s = String(value).replace(/\s/g, '');
    return s.length > 0;
  }

  onSendSmsToUserFromOrder(order: any): void {
    if (!this.orderHasPhoneForSms(order)) {
      return;
    }
    const targetUserEmail = this.resolveTargetUserEmailForSms(order);
    if (!targetUserEmail) {
      this._snackBar.open(this.translate.instant('su-management.send-sms-to-user.error-no-email'), '', {
        duration: 4000,
        verticalPosition: 'top',
        panelClass: ['auto-width', 'center-text'].filter(Boolean),
      });
      return;
    }
    this.closeAllMenus();
    let branchId: string | undefined;
    try {
      const raw = localStorage.getItem('searchedBranchId');
      branchId = raw && raw !== 'null' && raw !== '' ? raw : undefined;
    } catch {
      branchId = undefined;
    }
    let printingService = '';
    try {
      const ps = localStorage.getItem('printingService');
      printingService = ps && ps !== 'null' ? ps : '';
    } catch {
      printingService = '';
    }
    this.dialogService.onOpenSuMessageToCustomerDialog({
      branch: null,
      printingService,
      state: 'sendSmsToUser',
      targetUserEmail,
      branchId,
      onUpdate: () => {},
    });
  }

  copyUserPhone(order: any): void {
    const phone = this.getOrderPhone(order);
    if (!phone) {
      return;
    }
    const phoneWithZero = String(phone).startsWith('0')
      ? String(phone)
      : '0' + String(phone);
    void copyTextToClipboard(phoneWithZero)
      .then(() => {
        this.translate
          .get(['su-management.branches_copy-success-phone', 'my-profile.phone'])
          .subscribe((res: { [key: string]: string }) => {
            const msg =
              res['su-management.branches_copy-success-phone'] +
              ' - ' +
              res['my-profile.phone'] +
              ' ' +
              phoneWithZero;
            this._snackBar.open(msg, '', {
              duration: 5000,
              verticalPosition: 'bottom',
              panelClass: ['auto-width', 'center-text'].filter(Boolean),
            });
          });
      })
      .catch((err) => console.error('Could not copy phone: ', err))
      .finally(() => this.closeAllMenus());
  }

  onCheckBillingErrors(order: any): void {
    const orderId = order?._id ?? null;
    const userId =
      order?.userID?._id ?? order?.userID ?? (this.isManagementView ? this.userId : null) ?? null;
    if (!orderId || !userId) {
      this._snackBar.open(
        this.translate.instant('su-management.billing-errors-request-failed'),
        '',
        { duration: 5000, panelClass: ['auto-width'] }
      );
      return;
    }
    const orderForDialog = this.buildOrderForBillingErrorsDialog(order);
    this.ordersService.getTransactionsByOrder(userId, orderId).subscribe({
      next: (res) => {
        this.dialogService.onOpenBillingErrorsDialog(orderForDialog, res?.transactions ?? []);
        this.closeAllMenus();
      },
      error: () => {
        this._snackBar.open(
          this.translate.instant('su-management.billing-errors-request-failed'),
          '',
          { duration: 5000, panelClass: ['auto-width'] }
        );
        this.closeAllMenus();
      },
    });
  }

  /** מייל/טלפון לדיאלוג — במצב מנהל מהמשתמש המוצג */
  private buildOrderForBillingErrorsDialog(order: any): any {
    if (!order) {
      return order;
    }
    const email = this.resolveTargetUserEmailForSms(order) || order.user || order.userEmail;
    let userPhone = this.getOrderPhone(order);
    if (!this.hasMeaningfulPhoneValue(userPhone) && this.isManagementView && this.user?.phone) {
      userPhone = this.user.phone;
    }
    return { ...order, user: email || order.user, userEmail: email || order.userEmail, userPhone };
  }

  onCheckPrintNodeStatus(order: any): void {
    const id = order?._id;
    if (!id) {
      this._snackBar.open(this.translate.instant('su-management.printnode-status-request-failed'), '', {
        duration: 5000,
        panelClass: ['auto-width'],
      });
      return;
    }
    const expressBase = (
      order.printerID?.serverAddress ||
      this.expressServerAdress ||
      ""
    ).replace(/\/$/, "");
    if (!expressBase) {
      this._snackBar.open(this.translate.instant('su-management.printnode-status-request-failed'), '', {
        duration: 5000,
        panelClass: ['auto-width'],
      });
      return;
    }
    this.ordersService.getPrintNodeStatus(expressBase, id).subscribe({
      next: (res) => {
        console.log('[PrintNode status]', id, res);
        if (isPrintNodeStatusNegativeResponse(res)) {
          this._snackBar.open(this.translate.instant('su-management.printnode-status-negative'), '', {
            duration: 6000,
            panelClass: ['auto-width'],
          });
          return;
        }
        this.dialogService.onOpenPrintNodeStatusDialog(id, res);
      },
      error: (err) => {
        console.error('[PrintNode status]', id, err);
        const msg = messageForPrintNodeHttpError(
          err,
          this.translate.instant('su-management.printnode-status-request-failed'),
          this.translate.instant('su-management.printnode-status-not-found')
        );
        this._snackBar.open(msg, '', { duration: 6000, panelClass: ['auto-width'] });
      },
    });
    this.closeAllMenus();
  }

  copyOrderDetails(order: any): void {
    let service: string;
    let location: string;
    let pages = 0;
    if (this.isPHOrder(order)) {
      service = 'PH';
      location = order.productID?.name || '3D';
      pages = order.files?.reduce((total, file) => total + (file.images?.length || 1), 0) || 0;
    } else {
      service = `${order.branchID?.is_express
        ? order.printerID?.isPicsPrinter
          ? 'Pics'
          : 'Express'
        : 'Plotter'
        }`;
      location = order.branchID?.is_express ? order.printerID?.serial_name : order.branchID?.serial_name;
      if (service === 'Plotter') {
        pages = order.totalOrderLength;
      } else {
        pages = order.files?.reduce((total, file) => total + (file.images?.length || 0), 0) || 0;
      }
    }
    const userId = order.userID?._id || order.userID;
    const linkUrl = (this.isManagementView && this.isPHOrder(order))
      ? `https://print.eazix.io/chat/manager/${order._id}`
      : `https://print.eazix.io/userorders/${userId}/${order._id}`;
    const details = `*EAZIX ORDER*: User: *${order.user}* ,Printer *${service}*, *${location}*, Status: *${order.status}*, Pages: *${pages}*, Created: *${order.created}*, Costs: Card: *${order.totalCost ?? ''}* NIS + Eazix Points: *${order.pointsCost ?? ''}*, link: _${linkUrl}_, Order ID: *${order._id}*`;
    void copyTextToClipboard(details)
      .then(() => {
        this._snackBar.open(this.translate.instant('su-management.branches_copy-success-order'), '', {
          duration: 1500,
          panelClass: ['auto-width', 'center-text'].filter(Boolean),
        });
      })
      .catch((err) => console.error('Could not copy text: ', err))
      .finally(() => this.closeAllMenus());
  }

  copyTechnicalInfo(order: any): void {
    if (!order) return;
    const text = JSON.stringify(order, null, 2);
    void copyTextToClipboard(text)
      .then(() => {
        this._snackBar.open(this.translate.instant('ph-order-action.copy-technical-info-success'), '', {
          duration: 2000,
          panelClass: ['auto-width'],
        });
      })
      .catch((err) => console.error('Could not copy text: ', err))
      .finally(() => this.closeAllMenus());
  }

  resendOrder(order: any, forceRasterize: boolean = false): void {
    if (!this.isManagementView || !order?.branchID) {
      return;
    }
    let serverAddress;
    // [plotter]
    if (!order.branchID.is_express) {
      serverAddress = order.printerID.serverAddress
        ? order.printerID.serverAddress
        : '';
      this.http
        .post(serverAddress + '/api/orders/print', {
          orderID: order._id,
          rePrint: true,
        })
        .subscribe({
          next: (response) => {
            // Success handling
            // console.log('Success:', response);
            setTimeout(() => {
              this._snackBar.open(
                this.translate.instant('su-management.resend-order.success'),
                '',
                {
                  duration: 5000,
                  verticalPosition: 'top',
                }
              );
            }, 2000);
          },
          error: (error) => {
            // Failure handling
            console.error('Error:', error);
          },
        });
      // [express]
    } else if (order.branchID.is_express) {
      const printCode = this.branchesService.buildExpressPrintingCode(
        order.branchID?.unique,
        order.branchID?.properties?.code
      );
      const printBody: {
        orderID: string;
        code: number;
        rePrint: boolean;
        forceRasterize?: boolean;
      } = {
        orderID: order._id,
        code: printCode,
        rePrint: true,
      };
      if (forceRasterize === true) {
        printBody.forceRasterize = true;
      }
      this.http
        .post(this.expressServerAdress + '/api/orders/print', printBody)
        .subscribe({
          next: (response) => {
            // Success handling
            // console.log('Success:', response);
            setTimeout(() => {
              this._snackBar.open(
                this.translate.instant('su-management.resend-order.success'),
                '',
                {
                  duration: 5000,
                  verticalPosition: 'top',
                }
              );
            }, 2000);
          },
          error: (error) => {
            // Failure handling
            if (
              error.error.message === 'NO_PRINTER_FOUND_WITH_THIS_CODE' ||
              error.error.message === 'QUEUE_NOT_EMPTY' ||
              error.error.message === 'MISSING_PAPER_TYPES' ||
              error.error.message === 'PAYMENT_ERROR' ||
              error.error.message === 'PAYMENT_ERRORRROR_MOVING_FILES'
            ) {
              console.error('Error:', error);
            }
          },
        });
    }
    this.closeAllMenus();
  }

  cancelOrder(order: any, action: string) {
    let service = 'plotter';
    if (order.branchID?.is_express) {
      service = 'express';
    }
    this.branchesService.onCancelOrder(service, action, order._id).subscribe(
      (res) => {
        this.dataSharingService.notifyPendingOrderDecrement();
        this._snackBar.open(
          this.translate.instant(
            'su-management.cancel-order.' + res.status + '.success'
          ),
          '',
          {
            duration: 5000,
            verticalPosition: 'top',
          }
        );
      },
      (error) => {
        console.error('error cancelling order', error);
      }
    );
  }

  /** פותח דיאלוג שליחה מחדש של חלק מהקבצים (פלוטר / אקספרס). */
  onOpenResendPartialFilesDialog(order: any, forceRasterize: boolean = false): void {
    if (!order?._id) return;
    this.closeAllMenus();
    const orderType = this.getOrderFilesSystem(order) === 'express' ? 'express' : 'plotter';
    const expressPrintCode =
      orderType === 'express'
        ? this.branchesService.buildExpressPrintingCode(
            order.branchID?.unique,
            order.branchID?.properties?.code
          )
        : undefined;
    const expressServerAddress =
      orderType === 'express'
        ? order.printerID?.serverAddress || this.expressServerAdress
        : undefined;
    this.dialogService.onOpenResendPartialFilesDialog(
      order,
      orderType,
      orderType === 'express' && forceRasterize === true,
      expressPrintCode,
      expressServerAddress
    );
  }

  /** זיכוי באשראי – פותח דיאלוג אישור (PH, פלוטר, אקספרס). */
  onOpenCreditOrderDialog(order: any, mode: 'credit' | 'points'): void {
    if (!order?._id) return;
    this.closeAllMenus();
    const orderType = this.isPHOrder(order)
      ? 'ph'
      : (this.getOrderFilesSystem(order) === 'express' ? 'express' : 'plotter');
    const service =
      orderType === 'ph'
        ? undefined
        : (this.getOrderFilesSystem(order) === 'express' ? 'express' : 'plotter');
    this.dialogService.onOpenCreditOrderDialog(order, mode, orderType, service);
  }

  /** צור הצעת מחיר – כמו בצ'אט (להזמנת PH ב-NOT_PAID במצב מנהל). */
  openCreatePriceQuoteDialog(order: any): void {
    if (!order?._id) return;
    this.closeAllMenus();
    this.dialogService.onOpenCreatePriceQuoteDialog(order);
  }

  /** התחלת ייצור הזמנת PH – פותח דיאלוג להזנת הערה אופציונלית. */
  onMarkProductionStarted(order: any): void {
    const orderId = order?._id;
    if (!orderId) return;
    this.closeAllMenus();
    this.dialogService.onOpenMarkProductionStartedDialog(order);
  }

  /** סיום ייצור הזמנת PH – פותח דיאלוג להזנת הודעה אופציונלית ללקוח. */
  onMarkProductionFinished(order: any): void {
    const orderId = order?._id;
    if (!orderId || this.markProductionFinishedLoading) return;
    this.closeAllMenus();
    this.dialogService.onOpenMarkProductionFinishedDialog(order);
  }

  /** ההזמנה הגיעה לכתובת – פותח דיאלוג להזנת הודעה אופציונלית ללקוח. */
  onMarkArrivedAtAddress(order: any): void {
    const orderId = order?._id;
    if (!orderId) return;
    this.closeAllMenus();
    this.dialogService.onOpenMarkArrivedAtAddressDialog(order);
  }

  getInkGradientEligibleFiles(order: any): any[] {
    if (!order?.files?.length) {
      return [];
    }
    return order.files.filter(
      (file: any) => Array.isArray(file.images) && file.images.length > 0
    );
  }

  getUserNameForOrderFile(file: any, order: any): string {
    if (file?.originalUserName?.trim()) {
      return file.originalUserName;
    }
    return order?.user || '';
  }

  openInkGradientDialogForFile(file: any, order: any): void {
    if (!this.isSU || !file || !order) {
      return;
    }
    this.closeAllMenus();
    this.dialogService.onOpenInkGradientDialog(
      file,
      this.expressServerAdress,
      this.getUserNameForOrderFile(file, order),
      order
    );
  }

  closeAllMenus() {
    this.menuTriggers.forEach((trigger) => trigger.closeMenu());
  }
  //  // ======================== MANIGMENT MODE ========================


  // ph
  isPHOrder(order: any): boolean {
    return order.collectionData ? true : false;
  }

  /**
   * בקשת תשלום SU בלבד.
   * בבאק מסומנת ב-fix_products_order.isEmptyOrder === true (createEmptyFixProductsOrder).
   * לא מתאימה להזמנות fix רגילות (יש branch/printer) או express/פלוטר/PH.
   */
  isEmptyFixProductsPaymentOrder(order: any): boolean {
    const fp = order?.fix_products_order;
    if (fp && typeof fp === 'object' && fp.isEmptyOrder === true) {
      return true;
    }
    // fallback: fix_products_order לא populated – חתימה ייחודית לבקשת תשלום SU
    if (
      fp &&
      typeof fp === 'string' &&
      order?.is_only_fix_products_in_order === true &&
      !order?.branchID &&
      !order?.printerID
    ) {
      return true;
    }
    return false;
  }

  getEmptyPaymentRequestAmount(order: any): number {
    const fromFix = order?.fix_products_order?.totalCost;
    if (fromFix != null && !Number.isNaN(Number(fromFix))) {
      return Number(fromFix);
    }
    return Number(order?.totalCost ?? 0);
  }

  isEmptyPaymentRequestPending(order: any): boolean {
    if (!this.isEmptyFixProductsPaymentOrder(order)) {
      return false;
    }
    if (order?.isDeleted || order?.status === 'CANCELLED') {
      return false;
    }
    const fpStatus = order?.fix_products_order?.status;
    if (fpStatus === 'CANCELLED') {
      return false;
    }
    return order?.status === 'PENDING' || fpStatus === 'PENDING';
  }

  isEmptyPaymentRequestPaid(order: any): boolean {
    if (!this.isEmptyFixProductsPaymentOrder(order)) {
      return false;
    }
    const fpStatus = order?.fix_products_order?.status;
    return order?.status === 'DONE' || fpStatus === 'DONE';
  }

  getEmptyPaymentRequestPaidAt(order: any): string | Date | null {
    return (
      order?.fix_products_order?.creditedAt ||
      order?.creditedAt ||
      order?.addedToQueue ||
      null
    );
  }

  private resolveFixProductsOrderId(order: any): string | null {
    const fp = order?.fix_products_order;
    if (!fp) {
      return null;
    }
    if (typeof fp === 'string') {
      return fp;
    }
    const id = fp._id ?? fp.id;
    return id != null ? String(id) : null;
  }

  openEmptyPaymentRequestSummaryDialog(event: Event, order: any): void {
    event.stopPropagation();
    const fixId = this.resolveFixProductsOrderId(order);
    if (!fixId || !this.user) {
      return;
    }
    const amount = this.getEmptyPaymentRequestAmount(order);
    const hasSavedCC = !!(this.user?.zCreditInfo?.token && this.user.zCreditInfo.token !== '');
    syncIsNotAcademyFromOrder(order, 'express');
    this.dialogService.onOpenOrderSummaryDialog(
      'express',
      this.expressServerAdress,
      [],
      [],
      'payment-request',
      {
        totalOrderPriceBeforeDiscount: amount,
        totalOrderPrice: amount,
        points: 0,
        fixProductsTotalPrice: 0,
      },
      this.user,
      false,
      false,
      0,
      '',
      '',
      order._id,
      null,
      null,
      false,
      null,
      null,
      false,
      null,
      null,
      {
        fixProductsOrderId: fixId,
        expressOrderId: order._id,
        totalCost: amount,
        hasSavedCC,
      }
    );
  }

  /** הזמנת PH שבוטלה – ציר זמן: נוצרה (שליש) + בוטלה (שני שליש), בלי תא הזיכוי הירוק */
  isPhOrderCancelled(order: any): boolean {
    return this.isPHOrder(order) && order?.status === 'CANCELLED';
  }

  isPhOrderInPaidLifecycle(order: any): boolean {
    const status = order?.status;
    return (
      status === 'IN_PRODUCTION' ||
      status === 'STARTED_PRODUCTION' ||
      status === 'FINISHED_PRODUCTION' ||
      status === 'FINISHED_SHIPMENT'
    );
  }

  hasPhPaymentEvidence(order: any): boolean {
    if (!order) return false;
    if (order.paidAt) return true;
    if (order.zCreditRef) return true;
    const cc = Number(order.ccCost);
    return !Number.isNaN(cc) && cc > 0;
  }

  isPhOrderPaymentConfirmed(order: any): boolean {
    if (!order || !this.isPHOrder(order)) return false;
    if (order.status === 'CANCELLED' || order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS') {
      return false;
    }
    if (!this.isPhOrderInPaidLifecycle(order)) return false;
    return !!(order.adminOrder || this.hasPhPaymentEvidence(order));
  }

  /** משתמש יכול לבטל הזמנת PH רק לפני תשלום */
  canUserCancelPhOrder(order: any): boolean {
    if (!order || !this.isPHOrder(order)) return false;
    if (this.isPhOrderPaymentConfirmed(order)) return false;
    return order.status === 'NOT_PAID' || order.status === 'IN_QUOTATION';
  }

  /** אייקון phprint / 3dprint – לפי `productID.type` / `productID.name` כמו סיכום הזמנה ו־`getPhSystemIconSrcFromProduct` */
  getPhSystemIconSrcForOrder(order: any): string {
    if (!this.isPHOrder(order)) {
      return 'assets/images/phprint-icon.svg';
    }
    return getPhSystemIconSrcFromProduct(order?.productID);
  }

  /** שם מקום עם fallback לתרגום כש-translatedName חסר (למשל הזמנות ישנות משרת) */
  getPlaceDisplayName(place: any): string {
    if (!place) return '';
    if (place.translatedName) return place.translatedName;
    if (place.name) return this.translate.instant('choose-branch.naming.' + place.name);
    return '';
  }

  /** מפתח תרגום לכותרת "ההזמנה הגיעה..." לפי סוג האיסוף (משלוח / נקודת איסוף / מפעל) */
  getArrivedAtAddressTitleKey(order: any): string {
    const opt = order?.collectionData?.selectedCollectOption || order?.selectedCollectOption || '';
    if (opt === 'delivery') return 'chat.arrived-at-address-title-delivery';
    if (opt === 'pickup') return 'chat.arrived-at-address-title-factory';
    return 'chat.arrived-at-address-title-pickup-point';
  }

  /** כתובת מקום עם fallback לתרגום כש-translatedAddress חסר */
  getPlaceDisplayAddress(place: any): string {
    if (!place) return '';
    if (place.translatedAddress) return place.translatedAddress;
    if (place.name) return this.translate.instant('choose-branch.short-address.' + place.name);
    return '';
  }

  /** כתובת איסוף/משלוח לתצוגה – מחזירה מחרוזת מגוהצת (ללא רווח לפני הנקודה) */
  getCollectionAddressDisplay(order: any): string {
    const addr = order?.collectionData?.selectedCollectOption === 'delivery'
      ? (order?.collectionData?.deliveryAddress?.fullAddress || '')
      : this.getPlaceDisplayAddress(order?.selectedPlace || order?.collectionData?.selectedPlace);
    return (addr || '').trim();
  }

  /** עלות שירות איסוף/משלוח ברירת מחדל – ראה `ph-service-data.ts` */
  getCollectionServicePrice(service: string): number {
    return getPhCollectionServicePrice(service);
  }

  /** עלות איסוף/משלוח אפקטיבית – מ־הצעת המחיר האחרונה (selectedCollectPriceModified) או selectedCollectPrice או ברירת מחדל */
  getEffectiveCollectPrice(order: any): number {
    const opt = order?.collectionData?.selectedCollectOption ?? order?.selectedCollectOption;
    const defaultPrice = this.getCollectionServicePrice(opt || '');
    const modified = this.getLastPriceQuoteForOrder(order)?.selectedCollectPriceModified;
    if (modified != null && !isNaN(Number(modified))) return Number(modified);
    const price = order?.collectionData?.selectedCollectPrice ?? order?.selectedCollectPrice;
    return (price != null && Number(price) >= 0) ? Number(price) : defaultPrice;
  }

  /** תצוגת עלות איסוף/משלוח – הסכום האפקטיבי או "ללא חיוב" */
  getCollectionPriceDisplay(order: any): string {
    const num = this.getEffectiveCollectPrice(order);
    if (num <= 0) return this.translate.instant('collect.price.no-charge');
    return this.roundDownTowDecimal(num) + ' ' + this.translate.instant('printing-table.nis');
  }

  /** כשקיים מחיר מתוקן שונה מהמקורי – להצגת קו חוצה + ערך חדש (מקור: הצעת המחיר האחרונה) */
  getCollectionPriceModifiedDisplay(order: any): { original: string; modified: string } | null {
    const opt = order?.collectionData?.selectedCollectOption ?? order?.selectedCollectOption;
    const originalNum = (order?.collectionData?.selectedCollectPrice ?? order?.selectedCollectPrice) != null
      ? Number(order?.collectionData?.selectedCollectPrice ?? order?.selectedCollectPrice)
      : this.getCollectionServicePrice(opt || '');
    const modified = this.getLastPriceQuoteForOrder(order)?.selectedCollectPriceModified;
    if (modified == null || modified === originalNum) return null;
    const origStr = originalNum <= 0 ? this.translate.instant('collect.price.no-charge') : this.roundDownTowDecimal(originalNum) + ' ' + this.translate.instant('printing-table.nis');
    const modStr = Number(modified) <= 0 ? this.translate.instant('collect.price.no-charge') : this.roundDownTowDecimal(Number(modified)) + ' ' + this.translate.instant('printing-table.nis');
    return { original: origStr, modified: modStr };
  }

  is3DOrder(order: any): boolean {
    return order?.productID?.type === '3Dprint' || order?.productID?.type === '3D';
  }

  /** נרמול הזמנות 3D – images + printSettings מ-settings */
  normalizeOrderForDisplay(order: any): any {
    if (!this.is3DOrder(order) || !order.files) return order;
    const normalized = { ...order, files: (order.files || []).map((file: any) => {
      const placeholderImage = {
        index: 0, path: '/assets/images/box-icon.svg', scaleFactor: 100,
        imageHeight: 100, imageWidth: 100, origImageHeight: 100, origImageWidth: 100, origImageDPI: 300,
      };
      const images = file.images && file.images.length > 0
        ? file.images
        : [placeholderImage];
      const s = file.settings || file.printSettings || {};
      const printSettings = {
        ...(file.printSettings || {}),
        paperType: s.paperType || s.material || 'default',
        material: s.material,
        color: s.color,
        fill: s.fill,
        numOfCopies: s.numOfCopies ?? 1,
        postProduction: s.postProduction || [],
        estimatedLength: s.estimatedLength,
        estimatedWidth: s.estimatedWidth,
        estimatedHeight: s.estimatedHeight,
        usage: s.usage,
        usageOther: s.usageOther,
        additionalNotes: s.additionalNotes,
        bw: s.bw ?? false,
        rotation: s.rotation ?? 0,
        align: s.align || 'center',
      };
      return { ...file, images, printSettings };
    })};
    return normalized;
  }

  checkIfHavePhOrders(orders: any[]) {
    this.isPHOrderExisting = false;
    if (orders) {
      for (let order of orders) {
        if (this.isPHOrder(order)) {
          this.isPHOrderExisting = true;
          break;
        }
      }
    }
  }

  getOrderFilesSystem(order: any): any {
    if (
      order?.branchID?.is_express ||
      this.isPHOrder(order) ||
      this.isEmptyFixProductsPaymentOrder(order)
    ) {
      return 'express';
    }
    return 'plotter';
  }

  isOrderAddedToQueue(order) {
    if (!this.isPHOrder(order)) {
      return order.addedToQueue;
    }
    return order.status === 'PAID';
  }

  /** Share-to-wall: user mode, academic plotter/express only, sent-to-print only. */
  canShareOrderPage(order: any): boolean {
    if (this.isManagementView || !order) {
      return false;
    }
    if (this.isPHOrder(order) || this.is3DOrder(order) || this.isEmptyFixProductsPaymentOrder(order)) {
      return false;
    }
    if (!this.isOrderAddedToQueue(order)) {
      return false;
    }
    const isExpress = !!order?.branchID?.is_express;
    const isPlotter = !!order?.branchID && !order.branchID.is_express;
    if (!isExpress && !isPlotter) {
      return false;
    }
    const printingService = isExpress ? 'express' : 'plotter';
    return !resolveIsNotAcademyFromOrder(order, printingService);
  }

  /** Desktop-only tooltip for the share-to-wall button. */
  isShareWallTooltipDesktop(): boolean {
    return typeof window !== 'undefined' && window.innerWidth >= 992;
  }

  /** Express: one share control per file (all pages), not per thumbnail. */
  canShareExpressFile(order: any, file: any): boolean {
    return this.getExpressFileShareablePages(order, file).length > 0;
  }

  shareExpressFileToWall(order: any, file: any, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    const pages = this.getExpressFileShareablePages(order, file);
    if (!pages.length) {
      return;
    }
    const serialName = String(
      order?.printerID?.serial_name || order?.branchID?.serial_name || ''
    ).trim();
    if (!serialName) {
      return;
    }
    const byFileId = new Map<
      string,
      {
        file: any;
        images: Array<{ page: number; wallThumbUrl: string; wallRotation: 0 }>;
      }
    >();
    for (const page of pages) {
      const sourceFile = page.sourceFile || file;
      const fileId = String(
        sourceFile?._id || sourceFile?.fileId || file?._id || file?.fileId || ''
      ).trim();
      if (!fileId) {
        continue;
      }
      const pageNum =
        Number(page.image?.page) >= 1
          ? Number(page.image.page)
          : Number(page.sourcePageIndex) + 1;
      let entry = byFileId.get(fileId);
      if (!entry) {
        entry = { file: sourceFile, images: [] };
        byFileId.set(fileId, entry);
      }
      entry.images.push({
        page: pageNum,
        wallThumbUrl: page.wallThumbUrl,
        wallRotation: 0,
      });
    }
    if (!byFileId.size) {
      return;
    }
    const sessionFiles = Array.from(byFileId.entries()).map(
      ([fileId, entry]) => ({
        _id: fileId,
        fileId,
        originalName:
          entry.file?.originalFileName ||
          entry.file?.originalName ||
          entry.file?.fileName ||
          entry.file?.name ||
          file?._expressDisplayFileName ||
          '',
        name:
          entry.file?.fileName ||
          entry.file?.name ||
          entry.file?.originalName ||
          file?._expressDisplayFileName ||
          '',
        images: entry.images,
      })
    );
    this.wallSessionService.setWallSessionFiles(sessionFiles, {
      orderId: String(order?._id || ''),
      printingService: 'express',
      serverAddress: String(order?.printerID?.serverAddress || ''),
      serialName,
      userName: String(
        this.user?.username || this.user?.email || order?.user || ''
      ).trim(),
    });
    this.router.navigate(['/wall']);
  }

  private getExpressFileShareablePages(
    order: any,
    file: any
  ): Array<{
    sourceFile: any;
    image: any;
    sourcePageIndex: number;
    sourceFileIndex: number;
    wallThumbUrl: string;
  }> {
    if (!this.canShareOrderPage(order) || !file) {
      return [];
    }
    const items: any[] = [];
    if (file._isChunkedMerged) {
      for (const item of this.getExpressChunkedDisplayItemsForView(file)) {
        if (item?.type === 'image' && item.image) {
          items.push(item);
        }
      }
    } else {
      const images = Array.isArray(file.images) ? file.images : [];
      images.forEach((image: any, idx: number) => {
        items.push({
          type: 'image',
          image,
          sourceFile: file,
          sourceFileIndex: file._sourceFileIndex ?? 0,
          sourcePageIndex: file._splitExpressMerged
            ? file._sourcePageIndex ?? 0
            : idx,
        });
      });
    }
    const out: Array<{
      sourceFile: any;
      image: any;
      sourcePageIndex: number;
      sourceFileIndex: number;
      wallThumbUrl: string;
    }> = [];
    for (const item of items) {
      const wallThumbUrl = String(
        this.getImgExpress(order, item.image) || ''
      ).trim();
      if (!wallThumbUrl || isWallPlaceholderThumb(wallThumbUrl)) {
        continue;
      }
      out.push({
        sourceFile: item.sourceFile || file,
        image: item.image,
        sourcePageIndex: Number(item.sourcePageIndex) || 0,
        sourceFileIndex: Number(item.sourceFileIndex) || 0,
        wallThumbUrl,
      });
    }
    return out;
  }

  shareOrderPageToWall(
    order: any,
    file: any,
    image: any,
    pageIndex: number,
    event?: Event,
    fileIndex?: number
  ): void {
    event?.stopPropagation();
    event?.preventDefault();
    if (!this.canShareOrderPage(order) || !file || !image) {
      return;
    }
    const printingService: 'plotter' | 'express' = order?.branchID?.is_express
      ? 'express'
      : 'plotter';
    const page = Number(image?.page) >= 1 ? Number(image.page) : pageIndex + 1;
    const wallThumbUrl = this.resolveOrderWallThumb(
      order,
      image,
      printingService,
      fileIndex,
      pageIndex
    );
    if (!wallThumbUrl || isWallPlaceholderThumb(wallThumbUrl)) {
      return;
    }
    const fileId = String(file?._id || file?.fileId || '').trim();
    if (!fileId) {
      return;
    }
    const serialName =
      printingService === 'express'
        ? String(
            order?.printerID?.serial_name || order?.branchID?.serial_name || ''
          ).trim()
        : String(order?.branchID?.serial_name || '').trim();
    if (!serialName) {
      return;
    }
    this.wallSessionService.setPendingDirectShare({
      id: `${printingService}:${fileId}:${page}`,
      fileId,
      printingService,
      page,
      serialName,
      fileName:
        file?.originalFileName ||
        file?.originalName ||
        file?.fileName ||
        file?.name ||
        '',
      thumbUrl: wallThumbUrl,
      serverAddress: String(order?.printerID?.serverAddress || ''),
      orderId: String(order?._id || ''),
    });
    this.router.navigate(['/wall']);
  }

  private resolveOrderWallThumb(
    order: any,
    image: any,
    printingService: 'plotter' | 'express',
    fileIndex?: number,
    pageIndex?: number
  ): string {
    if (printingService === 'express') {
      return String(this.getImgExpress(order, image) || '').trim();
    }
    if (typeof fileIndex === 'number' && typeof pageIndex === 'number') {
      return String(this.getImgPlotter(order, fileIndex, pageIndex) || '').trim();
    }
    const thumb = String(image?.thumbnailPath || '').trim();
    const path = String(image?.path || '').trim();
    const http = [thumb, path].find((u) => /^https?:\/\//i.test(u));
    if (http) {
      return http;
    }
    return thumb || path || '';
  }

  /** האם יש מועד הדפסה (פלוטר/אקספרס) – לציר זמן: רק אם יש print_end מציגים שלב "הודפסה". */
  hasOrderPrintedTime(order: any): boolean {
    return !!(order?.print_end);
  }

  getResentTimes(order: any): any[] {
    if (!Array.isArray(order?.resentTimes)) {
      return [];
    }
    return order.resentTimes.filter((time: any) => !!time);
  }

  hasResentTimes(order: any): boolean {
    if (order?.resentData?.originalOrderId) {
      return false;
    }
    return this.getResentTimes(order).length > 0;
  }

  getFilePriceExpressPH(order: any, file: any): number {
    if (!this.isPHOrder(order)) {
      return this.roundDownTowDecimal(file.price);
    }
    const copies = file.price?.copies ? file.price.copies : 1;
    const pages = file.price?.pages ? file.price.pages : 1;
    const pricePerPage = file.price?.pricePerPage ? file.price.pricePerPage : 0;
    return this.roundDownTowDecimal(pricePerPage * copies * pages);
  }

  getPHDimensions(
    direction: string,
    order: any,
    file: any,
    image: any): number {
    const product = order?.productID;
    const settings = file?.printSettings || {};
    const paperType = settings.paperType;
    if (!product) return 0;
    const type = (product.types || []).find(t => t.name === paperType);
    let val = 0;
    const is3D = product.type === '3D' || product.type === '3Dprint';
    if (is3D) {
      // sizeMode חדש; תאימות לאחור: paperType === 'dynamic' (canvas ישנים).
      const fromFile = product.sizeMode === 'dynamic' || product.sizeMode === 'matchFile' || paperType === 'dynamic';
      if (fromFile) {
        if (direction === 'h') {
          val = (settings.printingHeight || 0) / 10;
        } else if (direction === 'w') {
          val = (settings.printingWidth || 0) / 10;
        }
      } else {
        if (direction === 'h') {
          val = type?.height / 10 || 0;
        } else if (direction === 'w') {
          val = type?.width / 10 || 0;
        }
      }
    } else {
      if (direction === 'h') {
        val = image.height || 0;
      } else if (direction === 'w') {
        val = image.width || 0;
      }
    }
    return this.roundDownTowDecimal(val);
  }

  // ==================== COLLECT

  /** מועד תשלום להזמנת PH – לתצוגת "שולמה" בציר IN_PRODUCTION. בודק paidAt, paymentDate, addedToQueue */
  getPHOrderPaidDate(order: any): Date | null {
    if (!order || !this.isPHOrder(order)) return null;
    const d = order.paidAt || order.paymentDate || order.addedToQueue;
    return d ? new Date(d) : null;
  }

  /** הצעת המחיר האחרונה שלא בוטלה – לתצוגת מחיר/ציר זמן. רק להזמנות PH. בודק lastPriceQuote, priceQuote (יחיד), או priceQuotes */
  getLastPriceQuoteForOrder(order: any): any {
    if (!order || !this.isPHOrder(order)) return null;
    const last = order?.lastPriceQuote;
    if (last && !last.isCancelled && (last.createdAt != null || last.orderPrice != null || last.totalPrice != null)) return last;
    const single = order?.priceQuote;
    if (single && !single.isCancelled && (single.createdAt != null || single.orderPrice != null)) return single;
    const pqs = (order?.priceQuotes || []).filter((pq: any) => !pq.isCancelled);
    if (pqs.length === 0) return null;
    return pqs.reduce((a, b) => (new Date((b?.createdAt || '')).getTime() > new Date((a?.createdAt || '')).getTime() ? b : a));
  }

  /** האם להציג סכום להזמנת PH – רק כשיש הצעת מחיר שלא בוטלה. בלי סכום משלוח/איסוף בלבד. */
  hasPHOrderDisplayPrice(order: any): boolean {
    if (!order || !this.isPHOrder(order)) return false;
    const quote = this.getLastPriceQuoteForOrder(order);
    return !!(quote && !quote.isCancelled);
  }

  /** מחיר לתצוגה להזמנת PH. תמיד מהסכום הכולל שהוזן בהצעת המחיר (orderPrice = הדפסה + משלוח). הערך מהשרת כבר בשקלים – אין חלוקה ב-10. */
  getPHOrderDisplayPrice(order: any): number | null {
    if (!order || !this.isPHOrder(order)) return null;
    const quote = this.getLastPriceQuoteForOrder(order);
    if (!quote || quote.isCancelled) return null;
    const fromQuote = quote?.orderPrice ?? quote?.totalPrice ?? quote?.price ?? quote?.amount ?? quote?.totalCost ?? order?.totalCost;
    const totalRaw = fromQuote != null ? Number(fromQuote) : 0;
    return totalRaw + (this.getOrderFixProductsPrice(order) || 0);
  }

  /** מחיר כולל לתצוגה להזמנת PH – עיגול לשני מקומות עשרוניים. בלי הכפלה ב-10 שמשבשת ערכים נכונים (למשל 21.5). */
  getPHOrderTotalForDisplay(order: any): number | null {
    if (!order || !this.isPHOrder(order)) return null;
    const raw = this.getPHOrderDisplayPrice(order);
    if (raw == null) return null;
    return this.roundDownTowDecimal(raw);
  }

  /** מחזיר מועד התחייבות מאובייקט הצעת מחיר – תומך ב-camelCase ו-snake_case */
  private getQuoteCommitment(quote: any): { obligatedDay?: string; obligatedDate?: string; obligatedTime?: string } {
    if (!quote) return {};
    return {
      obligatedDay: quote.obligatedDay ?? quote.obligated_day,
      obligatedDate: (quote.obligatedDate ?? quote.obligated_date ?? '').toString().trim() || undefined,
      obligatedTime: (quote.obligatedTime ?? quote.obligated_time ?? '').toString().trim() || undefined,
    };
  }

  /** האם יש להציג בלוק מועד אספקה – כשיש נתונים בהזמנה או בהצעת המחיר האחרונה */
  hasPHOrderCommitmentToShow(order: any): boolean {
    if (!order || !this.isPHOrder(order)) return false;
    const cd = order.collectionData;
    if (cd?.obligatedDate || cd?.obligatedDay || cd?.obligatedTime) return true;
    const q = this.getLastPriceQuoteForOrder(order);
    const c = this.getQuoteCommitment(q);
    return !!(c.obligatedDate || c.obligatedDay || c.obligatedTime);
  }

  /** האם מועד ההתחייבות בהצעת המחיר שונה מזה שבהזמנה (לפי הצעת המחיר האחרונה מה-Back) */
  isPriceQuoteCommitmentChanged(order: any): boolean {
    const priceQuoteData = this.getLastPriceQuoteForOrder(order);
    if (!order?.collectionData || !priceQuoteData) return false;
    const orderDate = (order.collectionData?.obligatedDate || '').toString().trim();
    const orderTime = (order.collectionData?.obligatedTime || '').toString().trim();
    const pq = this.getQuoteCommitment(priceQuoteData);
    const pqDate = (pq.obligatedDate || '').trim();
    const pqTime = (pq.obligatedTime || '').trim();
    if (!pqDate && !pqTime) return false;
    return (pqDate && pqDate !== orderDate) || (pqTime && pqTime !== orderTime);
  }

  /** מועד התחייבות לתצוגה – כשחל שינוי (לפי הצעת המחיר) מחזיר מהצעת המחיר, אחרת מ-collectionData */
  getOrderCommitmentDisplay(order: any): { obligatedDay?: string; obligatedDate?: string; obligatedTime?: string } {
    const last = this.getLastPriceQuoteForOrder(order);
    const fromQuote = last ? this.getQuoteCommitment(last) : {};
    if (last && this.isPriceQuoteCommitmentChanged(order)) {
      return {
        obligatedDay: fromQuote.obligatedDay || order?.collectionData?.obligatedDay,
        obligatedDate: fromQuote.obligatedDate || order?.collectionData?.obligatedDate,
        obligatedTime: fromQuote.obligatedTime ?? order?.collectionData?.obligatedTime,
      };
    }
    return {
      obligatedDay: order?.collectionData?.obligatedDay,
      obligatedDate: order?.collectionData?.obligatedDate,
      obligatedTime: order?.collectionData?.obligatedTime,
    };
  }

  /** נתוני מועד התחייבות להזמנת PH ב-IN_QUOTATION – מהצעת המחיר האחרונה או מ-collectionData */
  getInQuotationCommitment(order: any): { obligatedDay?: string; obligatedDate?: string; obligatedTime?: string } {
    if (!order || !this.isPHOrder(order) || order.status !== 'IN_QUOTATION') {
      return { obligatedDay: order?.collectionData?.obligatedDay, obligatedDate: order?.collectionData?.obligatedDate, obligatedTime: order?.collectionData?.obligatedTime };
    }
    const last = this.getLastPriceQuoteForOrder(order);
    const fromQuote = last ? this.getQuoteCommitment(last) : {};
    if (last && (fromQuote.obligatedDate || fromQuote.obligatedDay)) {
      return { obligatedDay: fromQuote.obligatedDay, obligatedDate: fromQuote.obligatedDate, obligatedTime: fromQuote.obligatedTime };
    }
    return {
      obligatedDay: order?.collectionData?.obligatedDay,
      obligatedDate: order?.collectionData?.obligatedDate,
      obligatedTime: order?.collectionData?.obligatedTime,
    };
  }

  /** תצוגת מועד התחייבות אחידה – משתמש ב-CommitmentTimeDisplayService */
  getCommitmentTimeText(order: any): string {
    if (!order?.collectionData?.selectedCollectOption) return '';
    const c = this.getOrderCommitmentDisplay(order);
    const date = (c?.obligatedDate || order?.collectionData?.obligatedDate || '').toString().trim();
    return this.commitmentTimeService.getCommitmentTimeDisplayText({
      selectedCollectOption: order.collectionData.selectedCollectOption as 'pickup' | 'points' | 'delivery',
      obligatedDay: c?.obligatedDay,
      obligatedDate: date,
      obligatedTime: c?.obligatedTime,
      collectionDaysDiff: this.commitmentTimeService.computeCollectionDaysDiff(date),
    });
  }

  collectionDaysDiff(order: any): number {
    if (!order.collectionData?.obligatedDate) return 0;

    const today = new Date();
    // פורמט: "4/9/2025" => יום/חודש/שנה
    const [day, month, year] = order.collectionData.obligatedDate.split('/').map(Number);
    const collectionDate = new Date(year, month - 1, day);

    // אפס את השעות כדי להשוות רק תאריך
    today.setHours(0, 0, 0, 0);
    collectionDate.setHours(0, 0, 0, 0);

    const diffTime = collectionDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  // // ==================== COLLECT

  /** trackBy לרשימת הזמנות — מזהה יציב ל-Angular */
  trackByOrderId(_index: number, order: any): string {
    return order?._id != null ? String(order._id) : `order-${_index}`;
  }

  /** trackBy לשורות קבצים (כולל expressFilesUi מפוצל ל-merged / chunked) */
  trackByOrderFileRow(_index: number, file: any): string {
    if (file?._isChunkedMerged) {
      return `chunk-m:${file._chunkGroupKey ?? file._id ?? _index}`;
    }
    const id = file?._id != null ? String(file._id) : '';
    const sfi = file?._sourceFileIndex;
    const spi = file?._sourcePageIndex;
    if (sfi != null || spi != null) {
      return `${id}:${sfi ?? 0}:${spi ?? 0}`;
    }
    return id ? `${id}-${_index}` : `file-${_index}`;
  }

  trackByExpressGridItem(_index: number, item: any): string {
    if (item?.type === 'partHeader') {
      return `ph:${item.partNumber}`;
    }
    return `img:${item.sourceFileIndex}:${item.sourcePageIndex}`;
  }

  /**
   * trackBy לתמונות בתוך קובץ — מונע הרכבה מחדש של <img> ברענון JSON (אותו URL).
   */
  trackByImageInFile(index: number, image: any): string {
    if (!image) {
      return `img-${index}`;
    }
    if (image._id != null) {
      return String(image._id);
    }
    return `${String(image.thumbnailPath ?? '')}|${String(image.path ?? '')}|${index}`;
  }

  /** פיצול תצוגה לקבצים מאוחדים (אקספרס בלבד) — חישוב פעם אחת בעת טעינה */
  private attachExpressMergedUiRows(orders: any[] | null | undefined): void {
    if (!orders?.length) {
      return;
    }
    for (const order of orders) {
      this.setExpressFilesUiOnOrder(order);
    }
  }

  /** פיצול "path1 | path2" / "name1 | name2" לקבצים ממוזגים (אקספרס) */
  private splitMergedOriginalPipeParts(file: any): { paths: string[]; names: string[] } {
    const sep = /\s*\|\s*/;
    const paths =
      typeof file?.originalFilePath === 'string'
        ? file.originalFilePath.split(sep).map((s) => s.trim()).filter(Boolean)
        : [];
    const names =
      typeof file?.originalFileName === 'string'
        ? file.originalFileName.split(sep).map((s) => s.trim()).filter(Boolean)
        : [];
    return { paths, names };
  }

  /** טביעת אצבע לנתונים שמשפיעים על expressFilesUi — למניעת בנייה מחדש מיותרת */
  private getExpressFilesUiFingerprint(order: any): string {
    const files = order?.files;
    if (!Array.isArray(files) || !files.length) {
      return '';
    }
    const mergeCtx = this.isExpressMergedSplitContext(order) ? '1' : '0';
    const status = String(order?.status ?? '');
    const parts = files.map((f: any) =>
      [
        f?._id ?? '',
        f?.isMerged ? '1' : '0',
        f?.isChunked ? '1' : '0',
        f?.images?.length ?? 0,
        String(f?.originalFilePath ?? ''),
        String(f?.originalFileName ?? ''),
        String(f?.fileName ?? ''),
        String(f?.filePath ?? ''),
        String(f?.processedFilePath ?? ''),
      ].join('\x1e')
    );
    return `${order?._id ?? ''}|${status}|${mergeCtx}|${parts.join('\x1f')}`;
  }

  private setExpressFilesUiOnOrder(order: any): void {
    if (!order?.files?.length) {
      order.expressFilesUi = [];
      delete order.__expressFilesUiFingerprint;
      return;
    }
    const fp = this.getExpressFilesUiFingerprint(order);
    if (
      order.__expressFilesUiFingerprint === fp &&
      Array.isArray(order.expressFilesUi) &&
      order.expressFilesUi.length > 0
    ) {
      return;
    }
    if (!this.isExpressMergedSplitContext(order)) {
      order.expressFilesUi = order.files.map((f: any, idx: number) => {
        const row: any = {
          ...f,
          _splitExpressMerged: false,
          _sourceFileIndex: idx,
          _sourcePageIndex: 0,
          _mergedPageCount: f.images?.length || 1,
        };
        row._expressDisplayFileName = this.computeExpressDisplayFileNameForRow(row);
        row._expressDisplayRowPrice = this.getExpressDisplayRowPrice(order, row);
        return row;
      });
      order.__expressFilesUiFingerprint = fp;
      return;
    }
    const rows: any[] = [];
    const consumedChunkKeys = new Set<string>();

    order.files.forEach((file: any, fileIndex: number) => {
      if (file?.isChunked === true) {
        const chunkKey = this.getExpressChunkGroupKey(file);
        if (consumedChunkKeys.has(chunkKey)) {
          return;
        }
        consumedChunkKeys.add(chunkKey);

        const chunkParts = order.files
          .map((f: any, idx: number) => ({ f, idx }))
          .filter(
            ({ f }) =>
              f?.isChunked === true && this.getExpressChunkGroupKey(f) === chunkKey
          );

        rows.push(this.buildExpressChunkedMergedRow(order, chunkParts, chunkKey));
        return;
      }

      this.appendExpressFileSourceRows(order, file, fileIndex, rows);
    });

    order.expressFilesUi = rows;
    order.__expressFilesUiFingerprint = fp;
  }

  private getExpressChunkGroupKey(file: any): string {
    const path = file?.originalFilePath;
    if (typeof path === 'string' && path.trim() !== '') {
      return path.trim();
    }
    return `__id:${String(file?._id ?? '')}`;
  }

  private getExpressChunkGroupDisplayName(file: any): string {
    return this.getDisplayFileNameAfterSplit(file);
  }

  getExpressChunkPartLabel(partNumber: number): string {
    return this.translate.instant('su-management.express-chunk-part', {
      part: partNumber,
    });
  }

  private buildExpressChunkedMergedRow(
    order: any,
    chunkParts: { f: any; idx: number }[],
    chunkGroupKey: string
  ): any {
    const firstFile = chunkParts[0].f;
    const displayItems: any[] = [];
    let partNumber = 0;

    for (const { f: partFile, idx: sourceIdx } of chunkParts) {
      partNumber++;
      displayItems.push({
        type: 'partHeader',
        partNumber,
        sourceFile: partFile,
        sourceFileIndex: sourceIdx,
      });
      (partFile.images ?? []).forEach((image: any, sourcePageIndex: number) => {
        displayItems.push({
          type: 'image',
          image,
          sourceFileIndex: sourceIdx,
          sourcePageIndex,
          sourceFile: partFile,
          isFirstPageOfSourceFile: sourcePageIndex === 0,
        });
      });
    }

    const allImages = displayItems
      .filter((item) => item.type === 'image')
      .map((item) => item.image);
    const totalPrice = chunkParts.reduce(
      (sum, { f }) => sum + this.getFilePriceExpressPH(order, f),
      0
    );

    const row: any = {
      ...firstFile,
      images: allImages,
      _isChunkedMerged: true,
      _chunkGroupKey: chunkGroupKey,
      _chunkedDisplayItems: displayItems,
      _chunkedImageCount: allImages.length,
      _chunkedSourceParts: chunkParts,
      _splitExpressMerged: false,
      _sourceFileIndex: chunkParts[0].idx,
      _sourcePageIndex: 0,
      _mergedPageCount: allImages.length,
      _expressDisplayFileName: this.getExpressChunkGroupDisplayName(firstFile),
      _expressDisplayRowPrice: this.roundDownTowDecimal(totalPrice),
    };
    return row;
  }

  /** Merged small-photo files stay at numOfCopies: 1; show source count on display rows only. */
  private applyExpressSourceCopiesToDisplayRow(row: any, img: any): void {
    if (img?.sourceNumOfCopies != null) {
      row.printSettings = {
        ...(row.printSettings || {}),
        numOfCopies: img.sourceNumOfCopies,
      };
    }
  }

  private appendExpressFileSourceRows(
    order: any,
    file: any,
    fileIndex: number,
    rows: any[]
  ): void {
    const finalizeRow = (row: any, img?: any) => {
      if (img) {
        this.applyExpressSourceCopiesToDisplayRow(row, img);
      }
      row._expressDisplayFileName = this.computeExpressDisplayFileNameForRow(row);
      row._expressDisplayRowPrice = this.getExpressDisplayRowPrice(order, row);
      rows.push(row);
    };

    if (file.isMerged && file.images && file.images.length > 1) {
      const pageCount = file.images.length;
      const { paths, names } = this.splitMergedOriginalPipeParts(file);
      const usePipeParts = paths.length > 1 || names.length > 1;
      file.images.forEach((img: any, pageIndex: number) => {
        const row: any = {
          ...file,
          images: [img],
          _splitExpressMerged: true,
          _sourceFileIndex: fileIndex,
          _sourcePageIndex: pageIndex,
          _mergedPageCount: pageCount,
        };
        if (usePipeParts) {
          if (paths.length > pageIndex) {
            row.originalFilePath = paths[pageIndex];
          }
          if (names.length > pageIndex) {
            row.originalFileName = names[pageIndex];
            row.fileName = names[pageIndex];
          }
          if (pageCount > 1 && names.length === pageCount) {
            row._mergedOriginalSplit = true;
          }
        }
        finalizeRow(row, img);
      });
      return;
    }

    const row: any = {
      ...file,
      _splitExpressMerged: false,
      _sourceFileIndex: fileIndex,
      _sourcePageIndex: 0,
      _mergedPageCount: file.images?.length || 1,
    };
    finalizeRow(row, file.images?.[0]);
  }

  /** במצב מנהל — מציגים כותרות "חלק N"; במצב משתמש — רק עמודים ברצף */
  private getExpressChunkedDisplayItemsForView(file: any): any[] {
    const items = file?._chunkedDisplayItems ?? [];
    if (!file?._isChunkedMerged || this.isManagementView) {
      return items;
    }
    return items.filter((item: any) => item.type !== 'partHeader');
  }

  getExpressFileFirstDisplayItem(file: any): any {
    if (file?._isChunkedMerged) {
      const items = this.getExpressChunkedDisplayItemsForView(file);
      return items[0] ?? null;
    }
    return {
      type: 'image',
      image: file?.images?.[0],
      sourceFileIndex: file?._sourceFileIndex ?? 0,
      sourcePageIndex: file?._sourcePageIndex ?? 0,
      sourceFile: file,
    };
  }

  getExpressFileGridDisplayItems(file: any): any[] {
    if (file?._isChunkedMerged) {
      const items = this.getExpressChunkedDisplayItemsForView(file);
      return items.length > 1 ? items.slice(1) : [];
    }
    if (file?.images?.length > 1 && !file._splitExpressMerged) {
      return file.images.slice(1).map((image: any, idx: number) => ({
        type: 'image',
        image,
        sourceFileIndex: file._sourceFileIndex,
        sourcePageIndex: idx + 1,
        sourceFile: file,
      }));
    }
    return [];
  }

  getExpressFileDisplayItemCount(file: any): number {
    if (file?._isChunkedMerged) {
      return this.getExpressChunkedDisplayItemsForView(file).length;
    }
    return file?.images?.length ?? 0;
  }

  getExpressFileImageCount(file: any): number {
    if (file?._isChunkedMerged) {
      return file._chunkedImageCount ?? file.images?.length ?? 0;
    }
    return file?.images?.length ?? 0;
  }

  shouldShowExpressFileSecondLine(file: any): boolean {
    return this.getExpressFileDisplayItemCount(file) > 1;
  }

  isExpressFileGridItemVisible(
    order: any,
    file: any,
    fileIndexInLoop: number,
    gridIndex: number
  ): boolean {
    const total = this.getExpressFileDisplayItemCount(file);
    if (total <= 14) {
      return true;
    }
    if (this.isAllImagesExpanded(order, file, fileIndexInLoop)) {
      return true;
    }
    const gridItems = this.getExpressFileGridDisplayItems(file);
    if (gridIndex >= gridItems.length) {
      return false;
    }
    return gridIndex < 12 || (total === 14 && gridIndex === 12);
  }

  isExpressFileGridItemHidden(
    order: any,
    file: any,
    fileIndexInLoop: number,
    gridIndex: number
  ): boolean {
    return !this.isExpressFileGridItemVisible(
      order,
      file,
      fileIndexInLoop,
      gridIndex
    );
  }

  getExpressFileImageSeqIndex(file: any, item: any): number {
    if (!file?._isChunkedMerged) {
      return item?.sourcePageIndex ?? 0;
    }
    if (item?.type !== 'image') {
      return 0;
    }
    let seq = 0;
    for (const di of this.getExpressChunkedDisplayItemsForView(file)) {
      if (di === item) {
        return seq;
      }
      if (di.type === 'image') {
        seq++;
      }
    }
    return 0;
  }

  shouldShowExpressPrinterStatus(order: any, file: any, item?: any): boolean {
    if (!this.isManagementView || !this.isOrderAddedToQueue(order)) {
      return false;
    }
    if (file?._isChunkedMerged) {
      return item?.type === 'image' && item.isFirstPageOfSourceFile === true;
    }
    return item === undefined || item === null;
  }

  getExpressPrinterStatusFile(file: any, item?: any): any {
    if (file?._isChunkedMerged && item?.sourceFile) {
      return item.sourceFile;
    }
    return file;
  }

  isExpressMergedSplitContext(order: any): boolean {
    return !!(
      order?.branchID?.is_express &&
      !this.isPHOrder(order) &&
      !this.is3DOrder(order)
    );
  }

  /** כמות קבצים להצגה: בהזמנות אקספרס קובץ ממוזג נספר כ-2 (images שלו) */
  getExpressFileDisplayCount(order: any): number {
    if (!order?.files?.length) return 0;
    if (!this.isExpressMergedSplitContext(order)) return order.files.length;
    return order.files.reduce((sum: number, f: any) => sum + (f?.isMerged ? (f?.images?.length || 1) : 1), 0);
  }

  getExpressDisplayRowPrice(order: any, file: any): number {
    if (file?._expressDisplayRowPrice != null) {
      return file._expressDisplayRowPrice;
    }
    const base = this.getFilePriceExpressPH(order, file);
    if (file._splitExpressMerged && file._mergedPageCount > 1) {
      return this.roundDownTowDecimal(base / file._mergedPageCount);
    }
    return base;
  }

  /** חישוב שם לתצוגה — נשמר ב־_expressDisplayFileName בעת בניית expressFilesUi כדי לא לקרוא מהתבנית בכל CD */
  private computeExpressDisplayFileNameForRow(file: any): string {
    const base = this.getDisplayFileNameAfterSplit(file);
    if (!file._splitExpressMerged || !file._mergedPageCount) {
      return base;
    }
    if (file._mergedOriginalSplit) {
      return base;
    }
    return `${base} (${file._sourcePageIndex + 1}/${file._mergedPageCount})`;
  }

  getExpressDisplayFileNameForRow(file: any): string {
    return file?._expressDisplayFileName ?? this.computeExpressDisplayFileNameForRow(file);
  }

  // Get display file name after split('-')[1] - returns originalFileName if exists, otherwise uses fileName.split('-')[1]
  getDisplayFileNameAfterSplit(file: any): string {
    if (!file) {
      return '';
    }
    // If originalFileName exists, return it as is (assuming it's already the clean name)
    if (file.originalFileName && file.originalFileName.trim() !== '') {
      return file.originalFileName;
    }
    // For fileName, use the existing split logic
    if (!file.fileName) {
      return '';
    }
    const parts = file.fileName.split('-');
    return parts.length > 1 ? parts[1] : file.fileName;
  }

  myOrdersPhPaperTypeNameKey(productName: string | null | undefined, paperType: string | null | undefined): string {
    return phProductMaterialI18nKey(productName ?? '', paperType ?? '');
  }

  // -----------------
}
